import { useState, useEffect, useMemo, useCallback, useRef } from "react";
import { createPortal } from "react-dom";
import { elakay_API, toImageUrl } from "../../../../config";
import { elakayAutoText } from "../../dataElakay";


let __elakayInfoSource;
const __setElakayInfoSource = (infoSource) => { if (infoSource) __elakayInfoSource = infoSource; };
const __elakayText = (key, fallback) =>
  __elakayInfoSource?.laguangeElakay?.("frontElakayHardcodedText", __elakayInfoSource.languageAPI)?.["designStudio"]?.[key] || fallback;

const getHardcodedText = (infoSource, group, key, fallback) =>
  infoSource?.laguangeElakay?.("frontElakayHardcodedText", infoSource.languageAPI)?.[group]?.[key] || fallback;

const CSS_ = `
@import url('https://fonts.googleapis.com/css2?family=Bebas+Neue&family=DM+Sans:wght@300;400;500;600;700&family=Space+Mono:wght@400;700&display=swap');
*,*::before,*::after{box-sizing:border-box;margin:0;padding:0}
:root{
  --n0:#f2f6fd;--n1:#ffffff;--n2:#f4f8fc;--n3:#eef6fb;--n4:#daeaf5;--n5:#c8ddea;
  --gold:#007399;--gold2:#00a4d8;--golda:rgba(0,115,153,.10);
  --teal:#4facfe;--teal2:#00f2fe;--teala:rgba(79,172,254,.10);
  --emerald:#34c759;--emeralda:rgba(52,199,89,.10);
  --white:#0d2d3d;--muted:#5a7a8a;--muted2:#8aa6b5;
  --ok:#34c759;--err:#ef4444;
  --b:rgba(0,115,153,.10);--b2:rgba(0,115,153,.18);
  --r:10px;--rL:18px;--tr:.18s ease;
  --ffd:'Bebas Neue',sans-serif;--ffb:'DM Sans',sans-serif;--ffm:'Space Mono',monospace;
}
html,body{font-family:var(--ffb);background:var(--n0);color:var(--white);min-height:100vh}
.sd-root{min-height:100vh;display:flex;flex-direction:column;background:var(--n0)}
.sd-topbar{display:flex;align-items:center;justify-content:space-between;padding:0 28px;height:56px;background:var(--n1);border-bottom:1px solid var(--b2);position:sticky;top:0;z-index:100;box-shadow:0 2px 24px rgba(0,0,0,.4);flex-shrink:0}
.sd-brand{display:flex;align-items:center;gap:10px}
.sd-logo{font-family:var(--ffd);font-size:22px;letter-spacing:3px;background:linear-gradient(135deg,var(--gold),var(--gold2));-webkit-background-clip:text;-webkit-text-fill-color:transparent;background-clip:text}
.sd-logo-tag{font-size:10px;color:var(--muted);letter-spacing:2px;text-transform:uppercase;padding-left:10px;border-left:1px solid var(--b2)}
.sd-topbar-right{display:flex;align-items:center;gap:10px}
.sd-steps{display:flex;align-items:center;gap:0;background:var(--n2);border:1px solid var(--b);border-radius:var(--rL);overflow:hidden}
.sd-step{display:flex;align-items:center;gap:8px;padding:8px 18px;cursor:pointer;transition:all var(--tr);border-right:1px solid var(--b);font-size:11px;font-weight:600;color:var(--muted)}
.sd-step:last-child{border-right:none}
.sd-step:hover:not(.sd-step--active){background:var(--b);color:var(--white)}
.sd-step--active{background:var(--golda);color:var(--gold)}
.sd-step--done{color:var(--ok)}
.sd-step-num{width:20px;height:20px;border-radius:50%;border:1.5px solid currentColor;display:flex;align-items:center;justify-content:center;font-family:var(--ffm);font-size:8px;font-weight:700;flex-shrink:0}
.sd-step--active .sd-step-num{background:var(--gold);border-color:var(--gold);color:#fff}
.sd-step--done .sd-step-num{background:var(--ok);border-color:var(--ok);color:#fff}
.sd-main{flex:1;padding:28px;max-width:1200px;width:100%;margin:0 auto}
.sd-sec-head{margin-bottom:20px}
.sd-sec-title{font-family:var(--ffd);font-size:28px;letter-spacing:2px;color:var(--white);margin-bottom:4px}
.sd-sec-sub{font-size:12px;color:var(--muted);line-height:1.5}
.sd-card{background:var(--n2);border:1px solid var(--b2);border-radius:var(--rL);overflow:hidden}
.sd-card-head{display:flex;align-items:center;gap:9px;padding:13px 18px;border-bottom:1px solid var(--b);background:linear-gradient(180deg,rgba(255,255,255,.03),transparent)}
.sd-card-icon{font-size:16px;flex-shrink:0}
.sd-card-title{font-size:13px;font-weight:700;color:var(--white);flex:1}
.sd-card-body{padding:16px 18px;display:flex;flex-direction:column;gap:12px}
.sd-slot-grid{display:grid;grid-template-columns:repeat(auto-fill,minmax(200px,1fr));gap:14px}
.sd-slot-card{background:var(--n3);border:1.5px solid var(--b2);border-radius:var(--r);overflow:hidden;position:relative;transition:all var(--tr);display:flex;flex-direction:column}
.sd-slot-card:hover{border-color:var(--teal);box-shadow:0 4px 20px rgba(0,180,216,.12)}
.sd-slot-card.add-card{border-style:dashed;display:flex;align-items:center;justify-content:center;flex-direction:column;gap:8px;min-height:200px;cursor:pointer;color:var(--muted)}
.sd-slot-card.add-card:hover{border-color:var(--gold);color:var(--gold);background:var(--golda)}
.sd-slot-img-wrap{position:relative;aspect-ratio:3/4;overflow:hidden;background:var(--n4)}
.sd-slot-img{width:100%;height:100%;object-fit:cover;display:block}
.sd-slot-img-placeholder{width:100%;height:100%;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:8px;color:var(--muted2)}
.sd-slot-badge{position:absolute;top:7px;left:7px;background:rgba(0,0,0,.75);border-radius:5px;font-size:8.5px;font-weight:700;color:#fff;padding:2px 7px}
.sd-slot-num{position:absolute;top:7px;right:7px;width:20px;height:20px;background:var(--gold);border-radius:50%;display:flex;align-items:center;justify-content:center;font-family:var(--ffm);font-size:9px;font-weight:700;color:#fff}
.sd-slot-ctrl{padding:10px 12px;display:flex;flex-direction:column;gap:7px}
.sd-slot-label-input{background:var(--n4);border:1px solid var(--b2);border-radius:6px;color:var(--white);font-size:11.5px;font-weight:600;padding:5px 9px;width:100%;outline:none;font-family:var(--ffb)}
.sd-slot-label-input:focus{border-color:var(--gold)}
.sd-slot-actions{display:flex;gap:5px}
.sd-slot-btn{flex:1;padding:5px 0;border-radius:6px;border:1px solid var(--b2);background:var(--n4);color:var(--muted);font-size:9.5px;font-weight:600;cursor:pointer;font-family:var(--ffb);display:flex;align-items:center;justify-content:center;gap:4px}
.sd-slot-btn:hover{border-color:var(--teal);color:var(--teal)}
.sd-slot-btn.danger:hover{border-color:var(--err);color:var(--err)}
.sd-slot-btn.primary{border-color:var(--gold);color:var(--gold)}
.sd-url-row{display:flex;gap:6px;align-items:center}
.sd-url-input{flex:1;background:var(--n4);border:1px solid var(--b2);border-radius:6px;color:var(--white);font-size:10px;padding:5px 8px;outline:none;font-family:var(--ffm)}
.sd-field{display:flex;flex-direction:column;gap:4px}
.sd-lbl{font-size:9px;font-weight:700;color:var(--muted);text-transform:uppercase;letter-spacing:.9px}
.sd-input,.sd-sel,.sd-ta{background:var(--n3);border:1px solid var(--b2);border-radius:7px;color:var(--white);font-family:var(--ffb);font-size:12px;padding:7px 10px;width:100%;outline:none}
.sd-input:focus,.sd-sel:focus,.sd-ta:focus{border-color:var(--gold);box-shadow:0 0 0 2px rgba(0,115,153,.12)}
.sd-ta{resize:vertical;min-height:64px}
.sd-sel{appearance:none;cursor:pointer;background-image:url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='7' fill='%237a8499'%3E%3Cpath d='M5 7L0 0h10z'/%3E%3C/svg%3E");background-repeat:no-repeat;background-position:right 10px center;padding-right:28px}
.sd-r2{display:grid;grid-template-columns:1fr 1fr;gap:10px}
.sd-studio{display:grid;grid-template-columns:1fr 370px;gap:0;min-height:calc(100vh - 160px);background:var(--n1);border:1px solid var(--b2);border-radius:var(--rL);overflow:hidden}
.sd-studio-left{display:flex;flex-direction:column;border-right:1px solid var(--b);overflow:hidden}
.sd-studio-right{overflow-y:auto;background:var(--n2)}
.sd-face-tabs{display:flex;align-items:center;border-bottom:1px solid var(--b);background:var(--n2);overflow-x:auto;flex-shrink:0}
.sd-face-tab{padding:8px 14px;border:none;background:transparent;color:var(--muted);font-size:10.5px;font-weight:500;cursor:pointer;border-bottom:2px solid transparent;white-space:nowrap;font-family:var(--ffb);display:flex;align-items:center;gap:5px;flex-shrink:0}
.sd-face-tab.on{color:var(--teal);border-bottom-color:var(--teal);background:var(--teala)}
.sd-face-dot{width:5px;height:5px;border-radius:50%;background:var(--emerald)}
.sd-face-thumbs{display:flex;gap:4px;padding:4px 10px;margin-left:auto;border-left:1px solid var(--b)}
.sd-face-thumb{width:32px;height:32px;border-radius:4px;border:1.5px solid var(--b);background:var(--n3);cursor:pointer;overflow:hidden;display:flex;align-items:center;justify-content:center}
.sd-face-thumb.on{border:2px solid var(--gold)}
.sd-face-thumb img{width:100%;height:100%;object-fit:cover}
.sd-canvas-zone{flex:1;display:flex;flex-direction:column;overflow:hidden}
.sd-zbar{display:flex;align-items:center;gap:6px;padding:5px 10px;background:var(--n2);border-bottom:1px solid var(--b)}
.sd-zbtn{width:24px;height:24px;border-radius:5px;border:1px solid var(--b2);background:var(--n3);color:var(--white);cursor:pointer;display:flex;align-items:center;justify-content:center}
.sd-zbtn:hover:not(:disabled){background:var(--teal)}
.sd-zbtn:disabled{opacity:.35;cursor:not-allowed}
.sd-zpct{font-family:var(--ffm);font-size:10px;color:var(--teal);min-width:34px;text-align:center}
.sd-zreset{padding:2px 7px;border:1px solid var(--b2);background:transparent;color:var(--muted);border-radius:5px;font-size:9.5px;cursor:pointer;font-family:var(--ffb)}
.sd-stage{flex:1;overflow:hidden;background:var(--n0);position:relative}
.sd-canvas{display:block;width:100%;touch-action:none}
.sd-chint{font-size:9px;color:var(--muted2);text-align:center;padding:3px 0;background:var(--n2);border-top:1px solid var(--b)}
.sd-toggle-text,.sd-dl-btn{padding:3px 9px;border-radius:5px;font-size:9.5px;font-weight:700;cursor:pointer;font-family:var(--ffb);display:flex;align-items:center;gap:4px}
.sd-toggle-text{border:1px solid rgba(0,115,153,0.35);background:rgba(0,115,153,0.08);color:var(--gold)}
.sd-toggle-text.off{border-color:rgba(255,255,255,0.12);background:transparent;color:var(--muted)}
.sd-dl-btn{border:1px solid rgba(52,199,89,0.35);background:rgba(52,199,89,0.08);color:var(--emerald)}
.sd-panel{display:flex;flex-direction:column}
.sd-sec{padding:11px 13px;border-bottom:1px solid var(--b);display:flex;flex-direction:column;gap:9px}
.sd-stitle{font-family:var(--ffd);font-size:14px;letter-spacing:1.5px;color:var(--white);display:flex;align-items:center;gap:7px}
.sd-stitle::after{content:'';flex:1;height:1px;background:linear-gradient(90deg,var(--b2),transparent)}
.sd-field2{display:flex;flex-direction:column;gap:3px}
.sd-lbl2{font-size:9px;font-weight:600;color:var(--muted);text-transform:uppercase;letter-spacing:.9px}
.sd-input2,.sd-sel2,.sd-ta2{background:var(--n3);border:1px solid var(--b2);border-radius:7px;color:var(--white);font-family:var(--ffb);font-size:11.5px;padding:6px 9px;width:100%;outline:none}
.sd-input2:focus,.sd-ta2:focus{border-color:var(--gold)}
.sd-ta2{resize:vertical;min-height:58px}
.sd-cw{position:relative}
.sd-cw .sd-input2{padding-right:36px}
.sd-cc{position:absolute;right:7px;top:50%;transform:translateY(-50%);font-size:8.5px;color:var(--muted);pointer-events:none}
.sd-r2b{display:grid;grid-template-columns:1fr 1fr;gap:8px}
.sd-chips{display:flex;flex-wrap:wrap;gap:4px}
.sd-chip{padding:3px 9px;border-radius:14px;border:1px solid var(--b2);background:var(--n3);color:var(--muted);font-size:9.5px;font-weight:500;cursor:pointer;font-family:var(--ffb)}
.sd-chip:hover{border-color:var(--gold);color:var(--white)}
.sd-chip.on{border-color:var(--gold);background:var(--golda);color:var(--gold)}
.sd-chip-sm{padding:2px 6px;font-size:9px}
.sd-srow{display:flex;align-items:center;gap:7px}
.sd-slider{flex:1;accent-color:var(--gold);cursor:pointer;height:3px}
.sd-sval{font-family:var(--ffm);font-size:9.5px;color:var(--gold);min-width:32px;text-align:right}
.sd-presets{display:flex;flex-wrap:wrap;gap:3px;margin-top:3px}
.sd-qgrid{display:grid;grid-template-columns:repeat(3,30px);gap:3px}
.sd-qbtn{height:26px;border-radius:5px;font-size:11px;cursor:pointer;background:var(--n3);border:1px solid var(--b2);color:var(--muted);font-family:var(--ffb)}
.sd-qbtn:hover{background:var(--teala);border-color:var(--teal);color:var(--teal)}
.sd-colors{display:flex;flex-wrap:wrap;gap:4px;align-items:center}
.sd-sw{width:20px;height:20px;border-radius:50%;border:2px solid transparent;cursor:pointer}
.sd-sw.on{border:2.5px solid var(--white);transform:scale(1.15)}
.sd-cpick{width:20px;height:20px;border-radius:50%;border:1.5px dashed rgba(255,255,255,.3);cursor:pointer;background:none;padding:0}
.sd-block-row{display:grid;grid-template-columns:repeat(4,1fr);gap:4px}
.sd-block-thumb{aspect-ratio:1;border-radius:5px;border:1.5px solid var(--b);background:var(--n3);display:flex;flex-direction:column;align-items:center;justify-content:center;cursor:pointer;position:relative;overflow:hidden;gap:2px;padding:3px}
.sd-block-thumb:hover{border-color:var(--teal)}
.sd-block-thumb.on{border:2px solid var(--gold);background:var(--golda)}
.sd-block-thumb.img-on{border:2px solid var(--teal)}
.sd-block-rm{position:absolute;top:2px;right:2px;width:13px;height:13px;background:rgba(239,68,68,.85);border:none;border-radius:50%;color:#fff;font-size:7px;cursor:pointer;display:flex;align-items:center;justify-content:center}
.sd-block-lbl{font-size:7.5px;color:var(--muted);text-align:center;line-height:1.1;max-width:100%;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}
.sd-edit-panel{padding:10px;background:rgba(0,115,153,.05);border:1px solid rgba(0,115,153,.18);border-radius:var(--r);display:flex;flex-direction:column;gap:8px}
.sd-edit-panel.teal{background:rgba(0,180,216,.06);border-color:rgba(0,180,216,.17)}
.sd-ep-title{font-size:9px;font-weight:700;text-transform:uppercase;letter-spacing:.7px}
.sd-ep-title.gold{color:var(--gold)}
.sd-ep-title.teal{color:var(--teal)}
.sd-drop{border:2px dashed var(--b2);border-radius:var(--r);padding:13px;display:flex;flex-direction:column;align-items:center;gap:5px;cursor:pointer;text-align:center}
.sd-drop:hover{border-color:var(--gold);background:rgba(0,115,153,.05)}
.sd-btn{display:inline-flex;align-items:center;gap:5px;padding:8px 16px;border-radius:var(--r);font-family:var(--ffb);font-size:11px;font-weight:600;cursor:pointer;border:none;transition:all var(--tr);letter-spacing:.3px;text-transform:uppercase}
.sd-btn-gold{background:linear-gradient(135deg,var(--gold),var(--gold2));color:#fff;box-shadow:0 4px 14px rgba(0,115,153,.28)}
.sd-btn-emerald{background:linear-gradient(135deg,var(--emerald),#34d399);color:#fff;box-shadow:0 4px 14px rgba(52,199,89,.25)}
.sd-btn-teal{background:linear-gradient(135deg,var(--teal),var(--teal2));color:#fff}
.sd-btn-sec{background:transparent;color:var(--white);border:1px solid var(--b2)}
.sd-btn-sec:hover{background:var(--b)}
.sd-btn-ghost{background:transparent;color:var(--muted);border:1px solid var(--b)}
.sd-btn-ghost:hover{color:var(--white)}
.sd-btn:disabled{opacity:.4;cursor:not-allowed;pointer-events:none}
.sd-output{background:var(--n2);border:1px solid var(--b2);border-radius:var(--rL);overflow:hidden}
.sd-json-pre{padding:20px;font-family:var(--ffm);font-size:10px;color:#0369a1;background:var(--n0);overflow-x:auto;white-space:pre;line-height:1.7;max-height:500px;overflow-y:auto}
.sd-json-pre .jk{color:#9333ea}
.sd-json-pre .jv{color:#16a34a}
.sd-json-pre .js{color:#ca8a04}
.sd-json-pre .jn{color:#0369a1}
.sd-copy-ok{color:var(--ok);font-size:10px;font-weight:600}
.sd-warn{padding:8px 12px;background:rgba(0,115,153,.07);border:1px solid rgba(0,115,153,.2);border-radius:8px;font-size:10.5px;color:var(--gold2);line-height:1.5}
.sd-info{padding:8px 12px;background:rgba(0,180,216,.07);border:1px solid rgba(0,180,216,.2);border-radius:8px;font-size:10.5px;color:var(--teal2);line-height:1.5}
.sd-ok{padding:8px 12px;background:rgba(52,199,89,.07);border:1px solid rgba(52,199,89,.2);border-radius:8px;font-size:10.5px;color:var(--emerald);line-height:1.5}
.sd-stats{display:flex;gap:12px;flex-wrap:wrap}
.sd-stat{background:var(--n3);border:1px solid var(--b);border-radius:var(--r);padding:10px 16px;display:flex;flex-direction:column;gap:3px;flex:1;min-width:100px}
.sd-stat-val{font-family:var(--ffm);font-size:22px;font-weight:700;color:var(--gold)}
.sd-stat-lbl{font-size:9.5px;color:var(--muted);text-transform:uppercase;letter-spacing:.8px}
.sd-progress-wrap{background:var(--n3);border-radius:20px;height:5px;overflow:hidden;margin-top:4px}
.sd-progress-fill{height:100%;border-radius:20px;background:linear-gradient(90deg,var(--teal),var(--emerald));transition:width .4s ease}
.sd-qbtn:disabled {
  background: var(--n4);
  color: var(--muted2);
  border-color: var(--b);
}
@media(max-width:900px){
  .sd-studio{grid-template-columns:1fr}
  .sd-studio-left{border-right:none;border-bottom:1px solid var(--b)}
  .sd-slot-grid{grid-template-columns:repeat(2,1fr)}
  .sd-main{padding:16px}
}
`;

// import { useState, useCallback, useEffect, useRef } from "react";

/* ══════════════════════════════════════════════════════
   useGraphicOrderSave
   
   Gère la persistance du graphic order :
   - saveDraft()  → localStorage (pas de backend)
   - checkout()   → backend + cleanup localStorage
   - autoSaveDraft() → debounced localStorage save
   - restore()    → reload depuis localStorage au mount
   
   Usage dans GraffitiConfigurator :
   
   const save = useGraphicOrderSave({ 
     productID, 
     authToken,
     onCheckoutSuccess: (data) => onAddToCart(data)
   });
   
   // À chaque changement :
   useEffect(() => {
     save.autoSaveDraft(currentPayload);
   }, [currentPayload]);
   
   // Bouton "Save Draft" :
   <button onClick={() => save.saveDraft(buildPayload())}>
     💾 Save Draft
   </button>
   
   // Bouton "Checkout" :
   <button onClick={() => save.checkout(buildPayload())}>
     🛒 Confirm
   </button>
══════════════════════════════════════════════════════ */

const STORAGE_KEY = "elakay_graphic_draft";
const STORAGE_TTL = 24 * 60 * 60 * 1000; // 24h
const AUTOSAVE_DELAY = 1500; // 1.5s after last change

const useGraphicOrderSave = ({
  productID,
  authToken = null,
  pubToken = "",
  apiUrl = null,           // backend endpoint, ex: "/api/graphic-order"
  orderId = null,                          /* 🆕 si présent → mode update */
  mode = "customer",                       /* 🆕 "customer" | "seller" */
  onCheckoutSuccess = () => {},
  onCheckoutError = () => {},
  enableAutoSave = true
} = {}) => {

  /* ─── STATES ─── */
  const [busy, setBusy] = useState(false);
  const [busyMode, setBusyMode] = useState(null); // "draft" | "checkout" | "autosave"
  const [savedStatus, setSavedStatus] = useState(null); // null | "draft" | "submitted"
  const [lastSavedAt, setLastSavedAt] = useState(null);
  const [error, setError] = useState(null);
  const [hasDraft, setHasDraft] = useState(false);
  const [validationErrors, setValidationErrors] = useState([]);

  /* ─── REFS ─── */
  const lastHashRef = useRef(null);
  const autoSaveTimerRef = useRef(null);
  const abortControllerRef = useRef(null);
  /* ═══════════════════════════════════════════════════
     VALIDATION — règles exactes du backend
  ═══════════════════════════════════════════════════ */
  const validate = useCallback((data) => {
    const errors = [];

    if (!data) {
      errors.push("No data to validate");
      return { valid: false, errors };
    }

    /* sourceType obligatoire */
    if (!data.sourceType) {
      errors.push("sourceType is required");
      return { valid: false, errors };
    }

    const validTypes = ["custom", "ask", "template"];
    if (!validTypes.includes(data.sourceType)) {
      errors.push(`Invalid sourceType: "${data.sourceType}"`);
      return { valid: false, errors };
    }

    /* ─── MODE CUSTOM ─── */
    if (data.sourceType === "custom") {
      /* Règles :
         - Le url face (slot.url) n'est PAS requis (le client peut faire simple)
         - On a besoin d'AU MOINS 1 contenu :
             - Soit 1+ text dans un slot
             - Soit 1+ image dans un slot
             - Soit les deux
         - Sinon → rien à customiser, refus */

      const slots = Array.isArray(data.slots) ? data.slots : [];

      if (slots.length === 0) {
        errors.push("Au moins une face doit être configurée");
        return { valid: false, errors };
      }

      /* Au moins un slot doit avoir du contenu (text ou layer) */
      const hasAnyContent = slots.some(slot => {
        const texts = slot.slotState?.texts || [];
        const layers = slot.slotState?.layers || [];

        /* Compter les texts "actifs" (avec content non-vide) */
        const activeTexts = texts.filter(t => t && t.content && t.content.trim().length > 0);

        /* Compter les layers "actifs" (avec urlImg ou file) */
        const activeLayers = layers.filter(l => {
          if (!l) return false;
          const url = l.urlImg || l.src || l.url || "";
          /* Layer actif si : urlImg HTTP valide, ou File présent */
          return (url && !url.startsWith("blob:") && !url.startsWith("data:"))
              || (l.file instanceof File);
        });

        return activeTexts.length > 0 || activeLayers.length > 0;
      });

      if (!hasAnyContent) {
        errors.push("Ajoute au moins un texte ou une image sur une face");
        return { valid: false, errors };
      }

      return { valid: true, errors: [] };
    }

    /* ─── MODE ASK ─── */
    if (data.sourceType === "ask") {
      /* Tout optionnel. On accepte même un ask "vide" — le seller verra et répondra.
         Pas de règle de validation stricte côté front. */
      return { valid: true, errors: [] };
    }

    /* ─── MODE TEMPLATE ─── */
    if (data.sourceType === "template") {
      if (!data.templateRef) {
        errors.push("Sélectionne un template avant de continuer");
        return { valid: false, errors };
      }

      /* Format ObjectId MongoDB : 24 chars hex */
      const isValidId = typeof data.templateRef === "string"
        && /^[a-f0-9]{24}$/i.test(data.templateRef);

      if (!isValidId) {
        errors.push("Template ID invalide");
        return { valid: false, errors };
      }

      return { valid: true, errors: [] };
    }

    errors.push("Unknown validation case");
    return { valid: false, errors };
  }, []);

  /* ═══════════════════════════════════════════════════
     UTILITY : compute hash to detect changes
  ═══════════════════════════════════════════════════ */
  const computeHash = useCallback((data) => {
    try {
      /* Hash léger : on prend juste les clés importantes */
      const sig = JSON.stringify({
        sourceType: data?.sourceType,
        slots: data?.slots?.map(s => ({
          slotId: s.slotId,
          texts: s.slotState?.texts?.length,
          layers: s.slotState?.layers?.length,
          instructions: s.slotState?.instructions
        })),
        askSellerData: data?.askSellerData,
        templateRef: data?.templateRef,
        variant: data?.variant,
        qty: data?.qty
      });
      return sig;
    } catch {
      return Math.random().toString(36);
    }
  }, []);

  /* ═══════════════════════════════════════════════════
     LOCAL STORAGE HELPERS
  ═══════════════════════════════════════════════════ */
  const writeLocalStorage = useCallback((data) => {
    if (!productID) return false;
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      const store = raw ? JSON.parse(raw) : {};

      /* Cleanup des entrées expirées */
      const now = Date.now();
      Object.keys(store).forEach(k => {
        if (store[k]?.expiresAt && store[k].expiresAt < now) delete store[k];
      });

      /* Sauvegarde de l'entrée actuelle */
      store[productID] = {
        ...data,
        savedAt: now,
        expiresAt: now + STORAGE_TTL
      };

      localStorage.setItem(STORAGE_KEY, JSON.stringify(store));
      return true;
    } catch (err) {
      console.warn("[useGraphicOrderSave] writeLocalStorage failed:", err);
      return false;
    }
  }, [productID]);

  const readLocalStorage = useCallback(() => {
    if (!productID) return null;
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return null;

      const store = JSON.parse(raw);
      const entry = store[productID];
      if (!entry) return null;

      /* Check expiration */
      if (entry.expiresAt && entry.expiresAt < Date.now()) {
        delete store[productID];
        localStorage.setItem(STORAGE_KEY, JSON.stringify(store));
        return null;
      }

      return entry;
    } catch (err) {
      console.warn("[useGraphicOrderSave] readLocalStorage failed:", err);
      return null;
    }
  }, [productID]);

  const clearLocalStorage = useCallback(() => {
    if (!productID) return false;
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return true;

      const store = JSON.parse(raw);
      delete store[productID];

      if (Object.keys(store).length === 0) {
        localStorage.removeItem(STORAGE_KEY);
      } else {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(store));
      }
      return true;
    } catch (err) {
      console.warn("[useGraphicOrderSave] clearLocalStorage failed:", err);
      return false;
    }
  }, [productID]);

  /* ═══════════════════════════════════════════════════
     SAVE DRAFT — localStorage only (no backend)
  ═══════════════════════════════════════════════════ */
  const saveDraft = useCallback(async (data, options = {}) => {
    const { silent = false, force = false } = options;

    if (!data) {
      setError(elakayAutoText("h_f882c9fa90ffef", "No data to save"));
      return false;
    }

    if (!productID) {
      setError(elakayAutoText("h_f1d8b248660312", "Product ID missing"));
      return false;
    }

    /* Déduplication via hash */
    const hash = computeHash(data);
    if (!force && hash === lastHashRef.current) {
      /* Rien à sauver */
      return true;
    }

    if (!silent) {
      setBusy(true);
      setBusyMode("draft");
    }
    setError(null);

    /* Petite latence simulée pour UX feedback */
    await new Promise(r => setTimeout(r, 100));

    const success = writeLocalStorage({
      productID,
      payload: data,
      sourceType: data.sourceType,
      variant: data.variant,
      qty: data.qty,
      totalPrice: data.totalPrice
    });

    if (success) {
      lastHashRef.current = hash;
      setSavedStatus("draft");
      setLastSavedAt(Date.now());
      setHasDraft(true);
    } else {
      setError(elakayAutoText("h_4f2a2b435cd894", "Failed to save draft locally"));
    }

    if (!silent) {
      setBusy(false);
      setBusyMode(null);
    }

    return success;
  }, [productID, computeHash, writeLocalStorage]);

  /* ═══════════════════════════════════════════════════
     AUTO-SAVE — debounced, silent localStorage save
  ═══════════════════════════════════════════════════ */
  const autoSaveDraft = useCallback((data) => {
    if (!enableAutoSave) return;
    if (!data) return;

    /* Cancel le timer précédent */
    if (autoSaveTimerRef.current) {
      clearTimeout(autoSaveTimerRef.current);
    }

    /* Schedule un nouveau save dans X ms */
    autoSaveTimerRef.current = setTimeout(() => {
      saveDraft(data, { silent: true });
    }, AUTOSAVE_DELAY);
  }, [enableAutoSave, saveDraft]);

  /* ═══════════════════════════════════════════════════
     CHECKOUT — submit to backend + clear localStorage
     
     C'est la méthode appelée quand l'utilisateur clique
     "Confirm" / "Checkout". Elle :
     1. Cancel l'auto-save en cours
     2. (Optionnel) Submit au backend si apiUrl + authToken
     3. Clear le localStorage
     4. Appelle onCheckoutSuccess(data) pour que le parent gère le cart
  ═══════════════════════════════════════════════════ */
  /* ═══════════════════════════════════════════════════
     CHECKOUT — comportement selon mode
  ═══════════════════════════════════════════════════ */
  const checkout = useCallback(async (data) => {
    if (!data) {
      setError(elakayAutoText("h_72e8052f2192ee", "No data to checkout"));
      return false;
    }

    /* Cancel auto-save en cours */
    if (autoSaveTimerRef.current) {
      clearTimeout(autoSaveTimerRef.current);
      autoSaveTimerRef.current = null;
    }

    setBusy(true);
    setBusyMode("checkout");
    setError(null);
    setValidationErrors([]);

    /* ─── Validation ─── */
    const validation = validate(data);
    if (!validation.valid) {
      setValidationErrors(validation.errors);
      setError(validation.errors[0]);
      setBusy(false);
      setBusyMode(null);
      onCheckoutError({ message: __elakayText("t067", "Validation failed"), errors: validation.errors });
      return false;
    }

    /* 🆕 ─── MODE SELLER : appel backend update ─── */
    if (mode === "seller" && orderId) {
      try {
        const { updateOrderGraphic } = await import("../../../auth/apiProduct");

        /* Build le graphic data avec graphicMade="seller" sur les slots */
        const graphicData = buildSellerGraphicData(data);

        const result = await updateOrderGraphic(
          { token: authToken, pubToken },
          orderId,
          graphicData,
          { mode: "seller", status: "in_review" }
        );

        if (result?.success === false) {
          throw new Error(result.error || "Update failed");
        }

        setSavedStatus("submitted");
        setLastSavedAt(Date.now());
        setBusy(false);
        setBusyMode(null);

        onCheckoutSuccess({ ...data, serverResponse: result });
        return true;

      } catch (err) {
        console.error("[checkout seller] Error:", err);
        setError(err.message || elakayAutoText("h_23778b5f7eb26d", "Failed to save"));
        setBusy(false);
        setBusyMode(null);
        onCheckoutError({ message: err.message });
        return false;
      }
    }

    /* ─── MODE CUSTOMER (par défaut) : localStorage uniquement ─── */
    const success = writeLocalStorage({
      productID,
      payload: data,
      sourceType: data.sourceType,
      variant: data.variant,
      qty: data.qty,
      totalPrice: data.totalPrice
    });

    if (!success) {
      console.warn("localStorage failed but proceeding");
    }

    lastHashRef.current = computeHash(data);
    setSavedStatus("submitted");
    setLastSavedAt(Date.now());
    setBusy(false);
    setBusyMode(null);

    onCheckoutSuccess(data);
    return true;

  }, [productID, mode, orderId, authToken, pubToken, validate, writeLocalStorage, computeHash, onCheckoutSuccess, onCheckoutError]);

  /* 🆕 ─── SAVE DRAFT EN MODE SELLER : appel backend update ─── */
  const saveDraftServer = useCallback(async (data) => {
    if (!orderId || mode !== "seller") {
      return await saveDraft(data, { force: true });
    }

    setBusy(true);
    setBusyMode("draft");
    setError(null);

    try {
      const { updateOrderGraphic } = await import("../../../auth/apiProduct");

      const graphicData = buildSellerGraphicData(data);

      const result = await updateOrderGraphic(
        { token: authToken, pubToken },
        orderId,
        graphicData,
        { mode: "seller", status: "in_review" }   /* draft = in_review côté seller */
      );

      if (result?.success === false) {
        throw new Error(result.error || "Save failed");
      }

      setSavedStatus("draft");
      setLastSavedAt(Date.now());
      setBusy(false);
      setBusyMode(null);

      return true;

    } catch (err) {
      console.error("[saveDraftServer] Error:", err);
      setError(err.message || elakayAutoText("h_4b0265323ed43a", "Failed to save draft"));
      setBusy(false);
      setBusyMode(null);
      return false;
    }
  }, [orderId, mode, authToken, pubToken, saveDraft]);

  /* ═══════════════════════════════════════════════════
     buildSellerGraphicData
     
     Construit le payload graphic pour le backend en mode seller :
     - sourceType reste celui du client (ex: "ask")
     - askSellerData reste intact (preuve)
     - slots: les slots créés par le seller avec graphicMade="seller"
  ═══════════════════════════════════════════════════ */
  const buildSellerGraphicData = (data) => {
    return {
      productID: productID,
      graphic: {
        /* Garde le sourceType d'origine (le client a choisi "ask") */
        sourceType: data.sourceType || "ask",

        /* Les slots créés par le seller */
        slots: (data.slots || []).map(s => ({
          ...s,
          graphicMade: "seller"   /* ← Le flag clé */
        })),

        /* Garde le contexte original si présent */
        askSellerData: data.askSellerData || null,
        templateMeta: data.templateMeta || null,
        templateRef: data.templateRef || null,

        /* Notes du seller */
        sellerNotes: data.sellerNotes || data.notes || ""
      }
    };
  };

  /* ═══════════════════════════════════════════════════
     RESTORE — charge un draft existant au mount
  ═══════════════════════════════════════════════════ */
  const restore = useCallback(() => {
    const saved = readLocalStorage();
    if (saved?.payload) {
      lastHashRef.current = computeHash(saved.payload);
      setHasDraft(true);
      setSavedStatus("draft");
      setLastSavedAt(saved.savedAt);
      return saved.payload;
    }
    return null;
  }, [readLocalStorage, computeHash]);

  /* ═══════════════════════════════════════════════════
     CLEAR — supprime tout (draft + state)
  ═══════════════════════════════════════════════════ */
  const clear = useCallback(() => {
    if (autoSaveTimerRef.current) {
      clearTimeout(autoSaveTimerRef.current);
      autoSaveTimerRef.current = null;
    }
    if (abortControllerRef.current) {
      abortControllerRef.current.abort();
    }
    clearLocalStorage();
    lastHashRef.current = null;
    setHasDraft(false);
    setSavedStatus(null);
    setLastSavedAt(null);
    setError(null);
    setBusy(false);
    setBusyMode(null);
  }, [clearLocalStorage]);

  /* ═══════════════════════════════════════════════════
     CLEANUP au unmount
  ═══════════════════════════════════════════════════ */
  useEffect(() => {
    return () => {
      if (autoSaveTimerRef.current) clearTimeout(autoSaveTimerRef.current);
      if (abortControllerRef.current) abortControllerRef.current.abort();
    };
  }, []);

  /* ═══════════════════════════════════════════════════
     CHECK draft existence au mount/productID change
  ═══════════════════════════════════════════════════ */
  useEffect(() => {
    const saved = readLocalStorage();
    setHasDraft(!!saved);
    if (saved) {
      setSavedStatus("draft");
      setLastSavedAt(saved.savedAt);
    }
  }, [productID, readLocalStorage]);

  /* ─── PUBLIC API ─── */
  return {
    /* Méthodes */
    saveDraft,
    saveDraftServer,    /* 🆕 pour mode seller */
    autoSaveDraft,
    checkout,
    restore,
    clear,
    validate,
    clearError: () => setError(null),

    /* States */
    busy,
    busyMode,
    savedStatus,
    lastSavedAt,
    error,
    hasDraft
  };
};

/* ══════════════════════════════════════════════════════
   HELPER : buildFormData
   
   Construit un FormData pour le backend.
   - JSON dans le champ "payload"
   - Files individuels nommés "layer_X_Y" et "ref_X"
══════════════════════════════════════════════════════ */
function buildFormData(data, productID) {
  const fd = new FormData();

  /* Le payload principal (slots, askSellerData, etc.) */
  const cleanPayload = JSON.parse(JSON.stringify(data));

  /* Extraction des Files éventuels */
  if (data.slots?.length > 0) {
    data.slots.forEach((slot, slotIdx) => {
      slot.slotState?.layers?.forEach((layer, layerIdx) => {
        if (layer.file instanceof File) {
          fd.append(`layer_${slotIdx}_${layerIdx}`, layer.file);
          /* On retire le File du payload JSON */
          if (cleanPayload.slots[slotIdx].slotState.layers[layerIdx]) {
            delete cleanPayload.slots[slotIdx].slotState.layers[layerIdx].file;
          }
        }
      });
    });
  }

  /* Extraction des references (mode Ask Seller) */
  if (data.askSellerData?.images) {
    data.askSellerData.images.forEach((ref, idx) => {
      if (ref instanceof File) {
        fd.append(`ref_${idx}`, ref);
      }
    });
    if (cleanPayload.askSellerData) {
      cleanPayload.askSellerData.images = data.askSellerData.images.map(r => !!r);
    }
  }

  fd.append("productID", productID);
  fd.append("payload", JSON.stringify(cleanPayload));

  return fd;
}


/* ══════════════════════════════════════════════════════
   useDesignSave_ — Hook centralisé de sauvegarde
══════════════════════════════════════════════════════ */
function useDesignSave({
  productID,
  authToken,
  buildOutput,
  autoSaveEnabled = true,
  autoSaveInterval = 30000,
  initialDesignId = null
}) {
  const [designId, setDesignId]         = useState(initialDesignId);
  const [savedStatus, setSavedStatus]   = useState(null);
  const [savedAt, setSavedAt]           = useState(null);
  const [error, setError]               = useState(null);
  const [busy, setBusy]                 = useState(false);
  const [busyMode, setBusyMode]         = useState(null);
  const [lastAutoSave, setLastAutoSave] = useState(null);

  const lastSavedHashRef = useRef(null);
  const designIdRef      = useRef(null);
  const isMountedRef     = useRef(true);

  useEffect(() => {
    if (initialDesignId !== designId) setDesignId(initialDesignId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initialDesignId]);

  useEffect(() => { designIdRef.current = designId; }, [designId]);
  useEffect(() => {
    isMountedRef.current = true;
    return () => { isMountedRef.current = false; };
  }, []);

  const computeHash = useCallback((output) => {
    try {
      const stripped = {
        label: output.label, style: output.style, detail: output.detail,
        slots: (output.slots || []).map(s => ({
          id: s.id, label: s.label, url: s.url,
          slotState: {
            texts: s.slotState?.texts || [],
            instructions: s.slotState?.instructions || "",
            layers: (s.slotState?.layers || []).map(l => ({
              _id: l._id || null,
              urlImg: l.urlImg || l.url || l.src || "",
              hasFile: l.file instanceof File,
              fileName: l.file?.name || null,
              fileSize: l.file?.size || null,
              size: l.size, rotation: l.rotation, opacity: l.opacity, pos: l.pos
            }))
          }
        }))
      };
      return JSON.stringify(stripped);
    } catch { return Math.random().toString(); }
  }, []);

  const sendDesign = useCallback(async (status, mode = null) => {
    if (!productID) { setError(elakayAutoText("h_fc525cf7d8b16e", "Missing productID")); return null; }

    const output = buildOutput();
    if (!output) return null;

    const { payload, files, stats } = buildSavePayload(output, productID, status);

    if (!stats.valid && status === "published") { setError(stats.error); return null; }

    setBusy(true);
    setBusyMode(mode || (status === "published" ? "publish" : "draft"));
    setError(null);

    try {
      const fd = new FormData();
      fd.append("productID", payload.productID);
      fd.append("status",    payload.status);
      fd.append("label",     payload.label);
      fd.append("style",     payload.style);
      fd.append("detail",    payload.detail);
      fd.append("slotsData", JSON.stringify(payload.slots));

      files.forEach(({ fieldName, file }) => fd.append(fieldName, file));

      const url = designIdRef.current
        ? `${elakay_API}/graphic-design/add-update/${designIdRef.current}`
        : `${elakay_API}/graphic-design/add-update/new`;

      const res = await fetch(url, {
        method: "POST",
        headers: authToken ? { "Authorization": `Bearer ${authToken}` } : {},
        body: fd
      });

      const contentType = res.headers.get("content-type") || "";
      if (!contentType.includes("application/json")) {
        const text = await res.text();
        const preview = text.slice(0, 100).replace(/\s+/g, " ");
        if (res.status === 404) throw new Error(`Route not found (404). Check URL: ${url}`);
        if (res.status >= 500)  throw new Error(`Server error (${res.status}). ${preview}`);
        throw new Error(`Non-JSON response (${res.status}). ${preview}...`);
      }

      const data = await res.json();
      if (!res.ok || !data.success) throw new Error(data.error || `HTTP error ${res.status}`);

      if (!isMountedRef.current) return null;

      setDesignId(data.design._id);
      setSavedStatus(data.design.status);
      const now = new Date();
      setSavedAt(now);
      if (mode === "auto") setLastAutoSave(now);
      lastSavedHashRef.current = computeHash(output);

      return data.design;

    } catch (err) {
      console.error("sendDesign error:", err);
      if (isMountedRef.current) setError(err.message || elakayAutoText("h_6cc153f0e5df62", "Network error"));
      return null;
    } finally {
      if (isMountedRef.current) { setBusy(false); setBusyMode(null); }
    }
  }, [productID, authToken, buildOutput, computeHash]);

  const saveDraft = useCallback(() => sendDesign("draft", "draft"), [sendDesign]);
  const publish   = useCallback(() => sendDesign("published", "publish"), [sendDesign]);

  const autoSave = useCallback(async () => {
    if (busy) return;
    if (!productID) return;
    const output = buildOutput();
    if (!output || (output.slots || []).length === 0) return;
    const currentHash = computeHash(output);
    if (currentHash === lastSavedHashRef.current) return;
    if (savedStatus === "published") return;
    await sendDesign("draft", "auto");
  }, [busy, productID, buildOutput, computeHash, savedStatus, sendDesign]);

  useEffect(() => {
    if (!autoSaveEnabled || !productID) return;
    const interval = setInterval(() => { autoSave(); }, autoSaveInterval);
    return () => clearInterval(interval);
  }, [autoSaveEnabled, productID, autoSaveInterval, autoSave]);

  const clearError = useCallback(() => setError(null), []);

  return {
    designId, savedStatus, savedAt, error, busy, busyMode, lastAutoSave,
    saveDraft, publish, autoSave, clearError
  };
}

/* ══════════════════════════════════════════════════════
   SaveStatusBar
══════════════════════════════════════════════════════ */
function SaveStatusBar({
  designId, savedStatus, savedAt, busy, busyMode, error, lastAutoSave,
  productID, onSaveDraft, onPublish, onClearError, compact = false, infoSource
}) {
  __setElakayInfoSource(infoSource);
  const text = (key, fallback) => getHardcodedText(infoSource, "designStudio", key, fallback);
  const formatTime = (date) => {
    if (!date) return "";
    return date.toLocaleTimeString("en-US", { hour: "2-digit", minute: "2-digit", second: "2-digit" });
  };

  const isPublished = savedStatus === "published";
  const isDraft     = savedStatus === "draft";

  return (
    <div style={{
      display:"flex", alignItems:"center", gap:10,
      padding: compact ? "6px 12px" : "10px 16px",
      background: error ? "rgba(239,68,68,.06)"
        : isPublished ? "rgba(52,199,89,.06)"
        : isDraft ? "rgba(0,180,216,.06)"
        : "var(--n2)",
      border: `1px solid ${error ? "rgba(239,68,68,.2)"
        : isPublished ? "rgba(52,199,89,.2)"
        : isDraft ? "rgba(0,180,216,.2)"
        : "var(--b)"}`,
      borderRadius:"var(--r)", flexWrap:"wrap", fontSize:11
    }}>
      <div style={{display:"flex",alignItems:"center",gap:6,flex:1,minWidth:200}}>
        {error ? (
          <>
            <span style={{fontSize:14}}>⚠️</span>
            <div>
              <div style={{color:"var(--err)",fontWeight:600}}>{text("t001", "Save error")}</div>
              <div style={{fontSize:10,color:"var(--err)",opacity:.85}}>{error}</div>
            </div>
            <button type="button" onClick={onClearError}
              style={{background:"transparent",border:"none",color:"var(--err)",cursor:"pointer",fontSize:14,marginLeft:4}}>✕</button>
          </>
        ) : busy ? (
          <>
            <span style={{fontSize:14}}>⏳</span>
            <div>
              <div style={{color:"var(--gold)",fontWeight:600}}>
                {busyMode === "auto"   && elakayAutoText("h_845b01108562c3", "Auto-saving...")}
                {busyMode === "draft"  && elakayAutoText("h_ae7e887517b0f2", "Saving...")}
                {busyMode === "publish" && elakayAutoText("h_d281c9f37a703a", "Publishing...")}
              </div>
            </div>
          </>
        ) : isPublished ? (
          <>
            <span style={{fontSize:14}}>✅</span>
            <div>
              <div style={{color:"var(--ok)",fontWeight:600}}>{text("t002", "Design Published")}</div>
              <div style={{fontSize:10,color:"var(--muted)"}}>{__elakayText("t068", "Visible to clients · Last update:")}{formatTime(savedAt)}
              </div>
            </div>
          </>
        ) : isDraft ? (
          <>
            <span style={{fontSize:14}}>💾</span>
            <div>
              <div style={{color:"var(--teal)",fontWeight:600}}>{text("t003", "Draft Saved")}</div>
              <div style={{fontSize:10,color:"var(--muted)"}}>
                {formatTime(savedAt)}
                {lastAutoSave && lastAutoSave.getTime() === savedAt?.getTime() &&
                  <span style={{marginLeft:6,opacity:.7}}>· {text("t004", "auto")}</span>}
              </div>
            </div>
          </>
        ) : (
          <>
            <span style={{fontSize:14,opacity:.5}}>○</span>
            <div>
              <div style={{color:"var(--muted)",fontWeight:500}}>{text("t005", "Not saved")}</div>
              <div style={{fontSize:10,color:"var(--muted2)"}}>
                {productID ? elakayAutoText("h_dd948f899bbf38", "Auto-save every 30s") : elakayAutoText("h_fc525cf7d8b16e", "Missing productID")}
              </div>
            </div>
          </>
        )}
      </div>

      {!compact && productID && !error && (
        <div style={{display:"flex",gap:6,alignItems:"center",flexShrink:0}}>
          <button type="button" className="sd-btn sd-btn-ghost"
            style={{padding:"5px 12px",fontSize:10}}
            onClick={onSaveDraft} disabled={busy}>{__elakayText("t069", "💾 Draft")}</button>
          <button type="button" className="sd-btn sd-btn-emerald"
            style={{padding:"5px 12px",fontSize:10}}
            onClick={onPublish} disabled={busy}>
            {isPublished ? elakayAutoText("h_64463edf91d13a", "🔄 Republish") : elakayAutoText("h_9e913c24a79b2e", "🚀 Publish")}
          </button>
        </div>
      )}
    </div>
  );
}

/* ══════════════════════════════════════════════════════
   SlotManager — Page complète étape 1
══════════════════════════════════════════════════════ */
function SlotManager({ setActiveSlotId, setPickerOpen, slots, onSlotsChange, onNext, infoSource }) {
  const text = (key, fallback) => getHardcodedText(infoSource, "designStudio", key, fallback);
  const fileRefs = useRef([]);

  const addSlot = () => {
    if (slots.length >= 8) return;
    onSlotsChange([...slots, { id:`s${Date.now()}`, label:`Face ${slots.length+1}`, url:"", localUrl:"" }]);
  };
  const removeSlot = (i) => {
    if (slots.length <= 1) return;
    onSlotsChange(slots.filter((_,idx)=>idx!==i));
  };
  const updateSlot = (i, patch) => onSlotsChange(slots.map((s,idx)=>idx===i?{...s,...patch}:s));
  const handleFile = (i, file) => {
    if (!file?.type.startsWith("image/")) return;
    updateSlot(i, { localUrl: URL.createObjectURL(file), fileName:file.name, file });
  };
  const moveSlot = (from, to) => {
    if (to<0 || to>=slots.length) return;
    const arr=[...slots]; const [el]=arr.splice(from,1); arr.splice(to,0,el);
    onSlotsChange(arr);
  };

  const validCount = slots.filter(s=>s.url||s.localUrl).length;
  const pct = Math.round((validCount/Math.max(slots.length,1))*100);

  return (
    <div style={{display:"flex",flexDirection:"column",gap:20}}>
      <div className="sd-stats">
        <div className="sd-stat">
          <span className="sd-stat-val">{slots.length}</span>
          <span className="sd-stat-lbl">{text("t006", "Configured Faces")}</span>
        </div>
        <div className="sd-stat">
          <span className="sd-stat-val">{validCount}</span>
          <span className="sd-stat-lbl">{text("t007", "With Image")}</span>
        </div>
        <div className="sd-stat">
          <span className="sd-stat-val">{8-slots.length}</span>
          <span className="sd-stat-lbl">{text("t008", "Free Slots")}</span>
        </div>
        <div className="sd-stat" style={{flex:2}}>
          <span className="sd-stat-val">{pct}%</span>
          <span className="sd-stat-lbl">{text("t009", "Completion")}</span>
          <div className="sd-progress-wrap">
            <div className="sd-progress-fill" style={{width:`${pct}%`}}/>
          </div>
        </div>
      </div>

      <div className="sd-warn">{__elakayText("t070", "ℹ️ Add up to")}<strong>{text("t010", "8 faces")}</strong>{__elakayText("t071", "of your product. Each face will get its own graffiti design in the next step.")}</div>

      <div className="sd-slot-grid">
        {slots.map((slot,i)=>(
          <div key={slot.id} className="sd-slot-card">
            <div className="sd-slot-img-wrap"
              onClick={() => { setActiveSlotId(slot.id); setPickerOpen(true)}}
              style={{cursor:"pointer"}}>
              {(slot.localUrl||slot.url) ? (
                <img src={slot.localUrl||slot.url} alt={slot.label} className="sd-slot-img"
                  onError={e=>{e.target.style.display="none";}}/>
              ) : (
                <div className="sd-slot-img-placeholder">
                  <span style={{fontSize:28}}>📷</span>
                  <span style={{fontSize:10,color:"var(--muted)",textAlign:"center"}}>{__elakayText("t072", "Click or drag")}<br/>{text("t011", "an image")}
                  </span>
                </div>
              )}
              <div className="sd-slot-num">{i+1}</div>
              {(slot.localUrl||slot.url)&&<div className="sd-slot-badge">✓ {text("t011", "Image")}</div>}
              <input ref={el=>fileRefs.current[i]=el} type="file" accept="image/*" style={{display:"none"}}
                onChange={e=>{handleFile(i,e.target.files[0]);e.target.value="";}}/>
            </div>

            <div className="sd-slot-ctrl">
              <input className="sd-slot-label-input" value={slot.label}
                onChange={e=>updateSlot(i,{label:e.target.value})}
                placeholder={text("t012", "Face name (e.g. Front)")}/>

              <div className="sd-url-row">
                <input className="sd-url-input" value={slot.url}
                  onChange={e=>updateSlot(i,{url:e.target.value})}
                  placeholder={text("t013", "Image URL (optional)")}/>
              </div>

              <div className="sd-slot-actions">
                <button type="button" className="sd-slot-btn" onClick={()=>moveSlot(i,i-1)} disabled={i===0} title={text("t014", "Up")}>↑</button>
                <button type="button" className="sd-slot-btn" onClick={()=>moveSlot(i,i+1)} disabled={i===slots.length-1} title={text("t015", "Down")}>↓</button>
                <button type="button" className="sd-slot-btn danger" onClick={()=>removeSlot(i)} disabled={slots.length<=1} title={text("t016", "Delete")}>🗑</button>
                <button type="button" className="sd-slot-btn primary" onClick={()=>fileRefs.current[i]?.click()} title={text("t017", "Change image")}>🖼️</button>
              </div>
            </div>
          </div>
        ))}

        {slots.length<8&&(
          <div className="sd-slot-card add-card" onClick={addSlot}>
            <span style={{fontSize:32}}>+</span>
            <span style={{fontSize:11,fontWeight:600}}>{text("t018", "Add a face")}</span>
            <span style={{fontSize:9.5}}>{slots.length}/8</span>
          </div>
        )}
      </div>

      <div style={{display:"flex",justifyContent:"flex-end",gap:10,paddingTop:8}}>
        <button type="button" className="sd-btn sd-btn-gold" onClick={onNext}>{__elakayText("t073", "Create the Design →")}</button>
      </div>
    </div>
  );
}

/* ══════════════════════════════════════════════════════
   ImagePickerModal
══════════════════════════════════════════════════════ */
const ImagePickerModal = ({ open, onClose, slots, setSlots, ImageGallery, images, slotId, infoSource }) => {
  __setElakayInfoSource(infoSource);
  const text = (key, fallback) => getHardcodedText(infoSource, "designStudio", key, fallback);

  useEffect(() => {
    if (!open) return;
    const h = (e) => { if (e.key === "Escape") onClose(); };
    window.addEventListener("keydown", h);
    return () => window.removeEventListener("keydown", h);
  }, [open, onClose]);

  useEffect(() => {
    if (!open) return;
    const original = document.body.style.overflow;
    const originalPadding = document.body.style.paddingRight;
    const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    document.body.style.overflow = "hidden";
    document.body.style.paddingRight = `${scrollbarWidth}px`;
    return () => {
      document.body.style.overflow = original;
      document.body.style.paddingRight = originalPadding;
    };
  }, [open]);

  if (!open) return null;

  const targetSlot = slots.find((s) => s.id === slotId);

  const handleSubmit = (e) => {
    e.preventDefault(); e.stopPropagation();
    if (!images) return;
    setSlots((prev) =>
      prev.map((s) => s.id === slotId ? { ...s, url: images, localUrl: "" } : s)
    );
    onClose();
  };

  const handleBackdrop = (e) => { if (e.target === e.currentTarget) onClose(); };

  const modalContent = (
    <>
      <style>{`
        @keyframes ipm-fade  { from{opacity:0} to{opacity:1} }
        @keyframes ipm-slide { from{transform:translateY(-50px);opacity:0} to{transform:translateY(0);opacity:1} }
        .ipm-backdrop {
          position: fixed; top: 0; left: 0; right: 0; bottom: 0;
          width: 100vw; height: 100vh; z-index: 1050;
          -webkit-backdrop-filter: blur(7px);
          backdrop-filter: blur(7px);
          animation: ipm-fade .15s linear;
          overflow: hidden;
        }
        .ipm-container {
          position: fixed; top: 0; left: 0; right: 0; bottom: 0;
          width: 100vw; height: 100vh; z-index: 1055;
          overflow-y: auto; overflow-x: hidden;
          display: flex; align-items: center; justify-content: center;
          padding: 16px; box-sizing: border-box; outline: 0;
        }
        .ipm-modal {
          position: relative; background: #0a0f1c;
          border: 1px solid rgba(0, 164, 216, 0.22);
          border-radius: 18px; overflow: hidden;
          display: flex; flex-direction: column;
          box-shadow: 0 40px 100px rgba(0, 0, 0, 0.78), 0 0 0 1px rgba(0, 115, 153, 0.10);
          animation: ipm-slide .25s cubic-bezier(.22,1,.36,1);
          width: 100%; max-width: 640px;
          max-height: calc(100vh - 32px); margin: auto;
        }
        @media (min-width: 640px) { .ipm-container { padding: 24px; } .ipm-modal { max-width: 700px; max-height: calc(100vh - 48px); } }
        @media (min-width: 1024px) { .ipm-container { padding: 32px; } .ipm-modal { max-width: 900px; max-height: calc(100vh - 64px); } }
        @media (min-width: 1440px) { .ipm-modal { max-width: 1060px; max-height: calc(100vh - 96px); } }
        .ipm-header {
          display: flex; align-items: center; justify-content: space-between;
          padding: 16px 20px; border-bottom: 1px solid rgba(230, 240, 255, 0.07);
          flex-shrink: 0;
          background: linear-gradient(180deg, rgba(0,115,153,0.10), transparent);
        }
        .ipm-title { font-size: 14px; font-weight: 700; color: #e6f0ff; margin: 0; }
        .ipm-subtitle { font-size: 11px; color: #8a93a8; margin: 0; }
        .ipm-subtitle span { color: #00a4d8; font-weight: 600; }
        .ipm-close {
          width: 32px; height: 32px; border-radius: 50%;
          background: rgba(230, 240, 255, 0.05);
          border: 1px solid rgba(230, 240, 255, 0.10);
          color: #8a93a8; font-size: 14px; cursor: pointer;
          display: flex; align-items: center; justify-content: center;
          transition: all .15s; flex-shrink: 0; padding: 0;
        }
        .ipm-close:hover {
          background: rgba(239, 68, 68, 0.14);
          border-color: rgba(239, 68, 68, 0.4); color: #ef4444;
        }
        .ipm-gallery-wrap {
          flex: 1; overflow-y: auto; padding: 16px 20px;
          min-height: 200px; scrollbar-width: thin;
          scrollbar-color: rgba(0,164,216,0.28) transparent;
        }
        .ipm-gallery-wrap::-webkit-scrollbar { width: 5px; }
        .ipm-gallery-wrap::-webkit-scrollbar-track { background: transparent; }
        .ipm-gallery-wrap::-webkit-scrollbar-thumb { background: rgba(0,164,216,0.28); border-radius: 3px; }
        .ipm-footer {
          border-top: 1px solid rgba(230, 240, 255, 0.07);
          padding: 12px 20px;
          display: flex; align-items: center; gap: 12px;
          flex-shrink: 0; background: #0f172a; flex-wrap: wrap;
        }
        .ipm-thumb {
          width: 52px; height: 52px; border-radius: 9px;
          flex-shrink: 0; background: #05070d; overflow: hidden;
          display: flex; align-items: center; justify-content: center;
        }
        .ipm-thumb img { width: 100%; height: 100%; object-fit: cover; }
        .ipm-info { flex: 1; min-width: 0; }
        .ipm-info-label { font-size: 10px; color: #8a93a8; }
        .ipm-info-url {
          font-size: 10px; color: #00a4d8;
          font-family: 'Space Mono', monospace;
          overflow: hidden; text-overflow: ellipsis; white-space: nowrap;
        }
        .ipm-btn-cancel, .ipm-btn-submit {
          padding: 9px 18px; border-radius: 8px;
          font-size: 11px; font-weight: 600;
          cursor: pointer; font-family: inherit; white-space: nowrap;
          border: 1px solid transparent; transition: all .15s;
        }
        .ipm-btn-cancel {
          background: rgba(230, 240, 255, 0.05);
          border-color: rgba(230, 240, 255, 0.10); color: #8a93a8;
        }
        .ipm-btn-cancel:hover { background: rgba(0, 115, 153, 0.12); color: #e6f0ff; }
        .ipm-btn-submit { padding: 9px 22px; font-weight: 700; display: flex; align-items: center; gap: 6px; }
        .ipm-btn-submit:not(:disabled) {
          background: linear-gradient(135deg, #007399, #00a4d8);
          border-color: #007399; color: #fff;
          box-shadow: 0 4px 16px rgba(0, 115, 153, 0.32);
        }
        .ipm-btn-submit:not(:disabled):hover {
          transform: translateY(-1px); box-shadow: 0 6px 22px rgba(0, 115, 153, 0.44);
        }
        .ipm-btn-submit:disabled {
          cursor: not-allowed;
          background: rgba(0, 115, 153, 0.12);
          border-color: rgba(0, 164, 216, 0.22);
          color: #8a93a8; opacity: 0.55;
        }
        @media (max-width: 480px) {
          .ipm-footer { flex-direction: column; align-items: stretch; }
          .ipm-btn-cancel, .ipm-btn-submit { width: 100%; justify-content: center; }
          .ipm-info { width: 100%; }
        }
      `}</style>

      <div className="ipm-backdrop" />

      <div className="ipm-container" onClick={handleBackdrop}>
        <div className="ipm-modal">
          <div className="ipm-header">
            <div>
              <p className="ipm-title">🖼️ {text("t019", "Choose an Image")}</p>
              {targetSlot && (
                <p className="ipm-subtitle">{__elakayText("t074", "Face:")}<span>{targetSlot.label}</span>
                </p>
              )}
            </div>
            <button type="button" className="ipm-close" onClick={onClose}>✕</button>
          </div>

          <div className="ipm-gallery-wrap">
            <ImageGallery />
          </div>

          <form className="ipm-footer" onSubmit={handleSubmit}>
            <div className="ipm-thumb"
              style={{ border: `1px solid ${images ? "rgba(0,180,216,0.5)" : "rgba(255,255,255,0.08)"}` }}>
              {images ? <img src={images} alt={text("t020", "preview")} /> : <span style={{ fontSize: 20 }}>📷</span>}
            </div>
            <div className="ipm-info">
              <div className="ipm-info-label">{text("t021", "Selected Image")}</div>
              <div className="ipm-info-url">{images || elakayAutoText("h_225dd093005957", "— no image selected —")}</div>
            </div>
            <button type="button" className="ipm-btn-cancel" onClick={onClose}>{text("t022", "Cancel")}</button>
            <button type="submit" className="ipm-btn-submit" disabled={!images}>
              <span>✓</span>{__elakayText("t075", "Add to Face")}</button>
          </form>
        </div>
      </div>
    </>
  );

  return createPortal(modalContent, document.body);
};

/* ══════════════════════════════════════════════════════
   🆕 FaceEditModal_ — Modal pour éditer une face dans le studio
══════════════════════════════════════════════════════ */
const FaceEditModal = ({setActiveSlotId, setPickerOpen,  open, onClose, slot, onSave, infoSource }) => {
  const text = (key, fallback) => getHardcodedText(infoSource, "designStudio", key, fallback);
  const [label, setLabel] = useState("");
  const [url, setUrl] = useState("");
  const [localFile, setLocalFile] = useState(null);
  const [localPreview, setLocalPreview] = useState("");
  const fileRef = useRef(null);

  useEffect(() => {
    if (!open || !slot) return;
    setLabel(slot.label || "");
    setUrl(slot.url || "");
    setLocalFile(null);
    setLocalPreview(slot.localUrl || "");
  }, [open, slot]);

  useEffect(() => {
    if (!open) return;
    const original = document.body.style.overflow;
    const originalPadding = document.body.style.paddingRight;
    const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    document.body.style.overflow = "hidden";
    document.body.style.paddingRight = `${scrollbarWidth}px`;
    return () => {
      document.body.style.overflow = original;
      document.body.style.paddingRight = originalPadding;
    };
  }, [open]);

  useEffect(() => {
    if (!open) return;
    const h = (e) => { if (e.key === "Escape") onClose(); };
    window.addEventListener("keydown", h);
    return () => window.removeEventListener("keydown", h);
  }, [open, onClose]);

  if (!open || !slot) return null;

  const handleFile = (file) => {
    if (!file?.type.startsWith("image/")) return;
    setLocalFile(file);
    setLocalPreview(URL.createObjectURL(file));
  };

  const handleSubmit = (e) => {
    e.preventDefault(); e.stopPropagation();

    const patch = { label: (label || "Untitled").trim() };

    if (localFile) {
      patch.localUrl = localPreview;
      patch.url = "";
      patch.file = localFile;
      patch.fileName = localFile.name;
    } else if (url !== slot.url) {
      patch.url = url.trim();
      patch.localUrl = "";
      patch.file = null;
      patch.fileName = "";
    }

    onSave(patch);
    onClose();
  };

  const displayPreview = localPreview || url || "";

  const modalContent = (
    <>
      <style>{`
        @keyframes fem-fade  { from{opacity:0} to{opacity:1} }
        @keyframes fem-slide { from{transform:translateY(-30px) scale(0.97);opacity:0} to{transform:translateY(0) scale(1);opacity:1} }
        .fem-backdrop {
          position: fixed; top: 0; left: 0; right: 0; bottom: 0;
          width: 100vw; height: 100vh; z-index: 1050;
          background: rgba(3, 6, 14, 0.85);
          -webkit-backdrop-filter: blur(7px);
          backdrop-filter: blur(7px);
          animation: fem-fade .15s linear;
        }
        .fem-container {
          position: fixed; top: 0; left: 0; right: 0; bottom: 0;
          width: 100vw; height: 100vh; z-index: 1055;
          overflow-y: auto; overflow-x: hidden;
          display: flex; align-items: center; justify-content: center;
          padding: 20px; box-sizing: border-box; outline: 0;
        }
        .fem-modal {
          position: relative; background: var(--n1);
          border: 1px solid rgba(0, 164, 216, 0.22);
          border-radius: var(--rL); overflow: hidden;
          box-shadow: 0 30px 80px rgba(0, 0, 0, 0.6);
          animation: fem-slide .25s cubic-bezier(.22,1,.36,1);
          width: 100%; max-width: 480px;
          max-height: calc(100vh - 40px); margin: auto;
          display: flex; flex-direction: column;
        }
        .fem-header {
          padding: 16px 20px;
          background: linear-gradient(180deg, rgba(0,115,153,.08), transparent);
          border-bottom: 1px solid var(--b);
          display: flex; align-items: center; gap: 12px; flex-shrink: 0;
        }
        .fem-header-icon {
          width: 38px; height: 38px; border-radius: 10px;
          background: rgba(0,115,153,.15);
          display: flex; align-items: center; justify-content: center;
          font-size: 18px; flex-shrink: 0;
        }
        .fem-header-info { flex: 1; }
        .fem-header-title { font-size: 14px; font-weight: 700; color: var(--white); }
        .fem-header-sub { font-size: 10.5px; color: var(--muted); margin-top: 2px; }
        .fem-close {
          width: 28px; height: 28px; border-radius: 7px;
          background: var(--n3); border: 1px solid var(--b2);
          color: var(--muted); cursor: pointer; font-size: 13px;
          display: flex; align-items: center; justify-content: center;
          padding: 0; flex-shrink: 0; transition: all .15s;
        }
        .fem-close:hover {
          background: rgba(239,68,68,.14);
          border-color: rgba(239,68,68,.4); color: var(--err);
        }
        .fem-body {
          padding: 18px 20px;
          overflow-y: auto; flex: 1;
          display: flex; flex-direction: column; gap: 14px;
        }
        .fem-preview {
          width: 100%; aspect-ratio: 4/3;
          background: var(--n3);
          border: 1.5px dashed var(--b2);
          border-radius: var(--r); overflow: hidden;
          display: flex; align-items: center; justify-content: center;
          position: relative; cursor: pointer; transition: all .15s;
        }
        .fem-preview:hover { border-color: var(--gold); border-style: solid; }
        .fem-preview img { width: 100%; height: 100%; object-fit: contain; }
        .fem-preview-empty {
          display: flex; flex-direction: column; align-items: center; gap: 6px;
          color: var(--muted); font-size: 11px;
        }
        .fem-preview-overlay {
          position: absolute; bottom: 0; left: 0; right: 0;
          padding: 6px 10px; background: rgba(0,0,0,.7);
          color: #fff; font-size: 9.5px; font-weight: 600;
          text-align: center; letter-spacing: 0.5px;
          text-transform: uppercase;
        }
        .fem-footer {
          padding: 12px 20px; background: var(--n2);
          border-top: 1px solid var(--b);
          display: flex; justify-content: flex-end; gap: 8px; flex-shrink: 0;
        }
      `}</style>

      <div className="fem-backdrop" />

      <div className="fem-container"
        onClick={e => { if (e.target === e.currentTarget) onClose(); }}>

        <div className="fem-modal">
          <div className="fem-header">
            <div className="fem-header-icon">✏️</div>
            <div className="fem-header-info">
              <div className="fem-header-title">{text("t023", "Edit Face")}</div>
              <div className="fem-header-sub">{text("t024", "Modify label, URL, or change the image")}</div>
            </div>
            <button type="button" className="fem-close" onClick={onClose}>✕</button>
          </div>

          <form onSubmit={handleSubmit} style={{display:"contents"}}>
            <div className="fem-body">

              {/* <div className="fem-preview" onClick={() => fileRef.current?.click()}> */}
               <div className="fem-preview" onClick={() =>  { setActiveSlotId(slot.id); setPickerOpen(true)}}>
                {displayPreview ? (
                  <>
                    <img src={displayPreview} alt={label}
                      onError={e => { e.target.style.display = "none"; }}/>
                    <div className="fem-preview-overlay">{text("t025", "Click to change image")}</div>
                  </>
                ) : (
                  <div className="fem-preview-empty">
                    <span style={{fontSize:32}}>📷</span>
                    <span>{text("t026", "Click to upload an image")}</span>
                  </div>
                )}
                <input ref={fileRef} type="file" accept="image/*"
                  style={{display:"none"}}
                  onChange={e => { handleFile(e.target.files[0]); e.target.value=""; }}/>
              </div>

              <div className="sd-field">
                <label className="sd-lbl">{text("t027", "Face name *")}</label>
                <input className="sd-input" value={label}
                  onChange={e => setLabel(e.target.value)}
                  placeholder={text("t028", "e.g. Front, Back, Left...")}
                  autoFocus/>
              </div>

              <div className="sd-field">
                <label className="sd-lbl">{text("t029", "Image URL (optional)")}</label>
                <input className="sd-input" value={url}
                  onChange={e => {
                    setUrl(e.target.value);
                    if (e.target.value) { setLocalFile(null); setLocalPreview(""); }
                  }}
                  placeholder="https://..."/>
                <div style={{fontSize:9.5, color:"var(--muted)", marginTop:3, lineHeight:1.4}}>{__elakayText("t076", "💡 Use either an upload (above) or a URL. Upload has priority.")}</div>
              </div>

            </div>

            <div className="fem-footer">
              <button type="button" className="sd-btn sd-btn-sec" onClick={onClose}>{text("t030", "Cancel")}</button>
              <button type="submit" className="sd-btn sd-btn-gold" disabled={!label.trim()}>{__elakayText("t077", "💾 Save Changes")}</button>
            </div>
          </form>
        </div>
      </div>
    </>
  );

  return createPortal(modalContent, document.body);
};

/* ══════════════════════════════════════════════════════
   🆕 ConfirmRemoveFaceModal — Confirmation suppression face
══════════════════════════════════════════════════════ */
const ConfirmRemoveFaceModal = ({ open, slot, onConfirm, onCancel, infoSource }) => {
  const text = (key, fallback) => getHardcodedText(infoSource, "designStudio", key, fallback);
  useEffect(() => {
    if (!open) return;
    const original = document.body.style.overflow;
    const originalPadding = document.body.style.paddingRight;
    const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    document.body.style.overflow = "hidden";
    document.body.style.paddingRight = `${scrollbarWidth}px`;
    return () => {
      document.body.style.overflow = original;
      document.body.style.paddingRight = originalPadding;
    };
  }, [open]);

  useEffect(() => {
    if (!open) return;
    const h = (e) => { if (e.key === "Escape") onCancel(); };
    window.addEventListener("keydown", h);
    return () => window.removeEventListener("keydown", h);
  }, [open, onCancel]);

  if (!open || !slot) return null;

  const modalContent = (
    <>
      <style>{`
        @keyframes crf-fade { from{opacity:0} to{opacity:1} }
        @keyframes crf-slide { from{transform:translateY(-20px);opacity:0} to{transform:translateY(0);opacity:1} }
        .crf-backdrop {
          position: fixed; top: 0; left: 0; right: 0; bottom: 0;
          width: 100vw; height: 100vh; z-index: 1060;
          background: rgba(3, 6, 14, 0.85);
          -webkit-backdrop-filter: blur(6px);
          backdrop-filter: blur(6px);
          animation: crf-fade .15s linear;
        }
        .crf-container {
          position: fixed; top: 0; left: 0; right: 0; bottom: 0;
          width: 100vw; height: 100vh; z-index: 1065;
          display: flex; align-items: center; justify-content: center;
          padding: 20px; box-sizing: border-box;
        }
        .crf-modal {
          background: var(--n1);
          border: 1px solid rgba(239,68,68,.3);
          border-radius: var(--rL); overflow: hidden;
          box-shadow: 0 30px 80px rgba(0,0,0,.6);
          animation: crf-slide .2s cubic-bezier(.22,1,.36,1);
          width: 100%; max-width: 400px;
        }
      `}</style>

      <div className="crf-backdrop" />

      <div className="crf-container"
        onClick={e => { if (e.target === e.currentTarget) onCancel(); }}>

        <div className="crf-modal">
          <div style={{
            padding:"18px 20px",
            background:"linear-gradient(180deg, rgba(239,68,68,.08), transparent)",
            borderBottom:"1px solid var(--b)",
            display:"flex", alignItems:"center", gap:12
          }}>
            <div style={{
              width:40, height:40, borderRadius:10,
              background:"rgba(239,68,68,.15)",
              display:"flex", alignItems:"center", justifyContent:"center",
              fontSize:20
            }}>🗑</div>
            <div>
              <div style={{fontSize:14, fontWeight:700, color:"var(--white)"}}>{__elakayText("t078", "Remove this face?")}</div>
              <div style={{fontSize:10.5, color:"var(--muted)", marginTop:2}}>{__elakayText("t079", "Its design, texts, and overlays will be lost.")}</div>
            </div>
          </div>

          <div style={{padding:"14px 20px"}}>
            <div style={{
              background:"var(--n3)",
              border:"1px solid var(--b)",
              borderRadius:"var(--r)",
              padding:"10px 12px",
              display:"flex", alignItems:"center", gap:10
            }}>
              {(slot.localUrl || slot.url) ? (
                <img src={slot.localUrl || slot.url} alt={slot.label}
                  style={{width:46, height:46, objectFit:"cover", borderRadius:6, flexShrink:0}}
                  onError={e => { e.target.style.display="none"; }}/>
              ) : (
                <div style={{
                  width:46, height:46, borderRadius:6,
                  background:"var(--n4)",
                  display:"flex", alignItems:"center", justifyContent:"center",
                  fontSize:18, flexShrink:0
                }}>📷</div>
              )}
              <div style={{flex:1, minWidth:0}}>
                <div style={{fontSize:13, fontWeight:700, color:"var(--white)"}}>{slot.label}</div>
                <div style={{fontSize:10, color:"var(--muted)", marginTop:2}}>{__elakayText("t080", "ID:")}{slot.id?.slice(-8)}</div>
              </div>
            </div>
          </div>

          <div style={{
            padding:"12px 20px",
            background:"var(--n2)",
            borderTop:"1px solid var(--b)",
            display:"flex", justifyContent:"flex-end", gap:8
          }}>
            <button type="button" className="sd-btn sd-btn-sec" onClick={onCancel}>{text("t031", "Cancel")}</button>
            <button type="button"
              style={{
                padding:"8px 18px",
                background:"linear-gradient(135deg, #dc2626, #ef4444)",
                color:"#fff", border:"none",
                borderRadius:"var(--r)", cursor:"pointer",
                fontSize:11, fontWeight:600, fontFamily:"var(--ffb)",
                textTransform:"uppercase", letterSpacing:.3,
                boxShadow:"0 4px 14px rgba(239,68,68,.35)"
              }}
              onClick={onConfirm}>{__elakayText("t081", "🗑 Remove Face")}</button>
          </div>
        </div>
      </div>
    </>
  );

  return createPortal(modalContent, document.body);
};

/* ══════════════════════════════════════════════════════
   buildSavePayload
══════════════════════════════════════════════════════ */
const buildSavePayload = (output, productID, status = "draft") => {
  if (!output || !productID) {
    return { payload: null, files: [], stats: { valid: false, error: __elakayText("t098", "Missing output or productID") } };
  }

  const files = [];
  let totalLayers=0, newLayers=0, totalTexts=0, validFaces=0, blobUrls=0;

  const cleanSlots = (output.slots || []).map((slot, si) => {

    const cleanLayers = (slot.slotState?.layers || []).map((layer, li) => {
      totalLayers++;
      const layerData = {
        urlImg: "",
        size:     typeof layer.size === "number"     ? layer.size     : 25,
        rotation: typeof layer.rotation === "number" ? layer.rotation : 0,
        opacity:  typeof layer.opacity === "number"  ? layer.opacity  : 100,
        pos: { x: layer.pos?.x ?? 50, y: layer.pos?.y ?? 50 }
      };

      if (layer._id) layerData._id = layer._id;

      if (layer.file instanceof File) {
        files.push({ fieldName: `layer_${si}_${li}`, file: layer.file });
        newLayers++;
      } else if (layer.urlImg && !layer.urlImg.startsWith("blob:")) {
        layerData.urlImg = layer.urlImg;
      } else if (layer.url && !layer.url.startsWith("blob:")) {
        layerData.urlImg = layer.url;
      } else if (layer.src && !layer.src.startsWith("blob:")) {
        layerData.urlImg = layer.src;
      } else if (layer.urlImg?.startsWith("blob:") || layer.url?.startsWith("blob:") || layer.src?.startsWith("blob:")) {
        blobUrls++;
      }
      return layerData;
    });

    const cleanTexts = (slot.slotState?.texts || []).map(tb => {
      totalTexts++;
      return {
        role: tb.role || "Text",
        content: (tb.content || "").slice(0, 24),
        fontId: tb.fontId || "impact",
        size: typeof tb.size === "number" ? tb.size : 56,
        color: tb.color || "#c9a227",
        outlineColor: tb.outlineColor || "#000000",
        outlineWidth: typeof tb.outlineWidth === "number" ? tb.outlineWidth : 2,
        shadowEnabled: !!tb.shadowEnabled,
        shadowColor: tb.shadowColor || "#000000",
        gradient: !!tb.gradient,
        gradColor: tb.gradColor || "#007399",
        textTransform: tb.textTransform || "uppercase",
        letterSpacing: typeof tb.letterSpacing === "number" ? tb.letterSpacing : 0,
        rotation: typeof tb.rotation === "number" ? tb.rotation : 0,
        opacity: typeof tb.opacity === "number" ? tb.opacity : 100,
        pos: { x: tb.pos?.x ?? 50, y: tb.pos?.y ?? 35 }
      };
    });

    const slotUrl = (() => {
      if (slot.url && !slot.url.startsWith("blob:")) return slot.url;
      if (slot.localUrl && !slot.localUrl.startsWith("blob:")) return slot.localUrl;
      if (slot.url?.startsWith("blob:")) blobUrls++;
      return "";
    })();

    if (slotUrl) validFaces++;

    return {
      id: slot.id || `slot_${si}_${Date.now()}`,
      label: slot.label || `Face ${si + 1}`,
      url: slotUrl,
      slotState: {
        texts: cleanTexts,
        layers: cleanLayers,
        instructions: (slot.slotState?.instructions || "").trim()
      }
    };
  });

  const payload = {
    productID, status,
    label:  (output.label  || "Untitled").trim(),
    style:  (output.style  || "Street Art").trim(),
    detail: (output.detail || "Moderate").trim(),
    slots:  cleanSlots
  };

  const stats = {
    valid: true,
    facesTotal: cleanSlots.length,
    facesWithImage: validFaces,
    textsTotal: totalTexts,
    layersTotal: totalLayers,
    layersToUpload: newLayers,
    blobUrls, filesToSend: files.length
  };

  if (status === "published") {
    if (!payload.label || payload.label === "Untitled") {
      stats.valid = false; stats.error = "Template name is required to publish";
    } else if (cleanSlots.length === 0) {
      stats.valid = false; stats.error = "At least one face is required to publish";
    } else if (validFaces < cleanSlots.length) {
      stats.valid = false; stats.error = `${cleanSlots.length - validFaces} face(s) without image`;
    } else if (blobUrls > 0) {
      stats.valid = false; stats.error = `${blobUrls} unsaved blob URL(s)`;
    }
  }

  return { payload, files, stats };
};

/* ══════════════════════════════════════════════════════
   CONSTANTES
══════════════════════════════════════════════════════ */
const PALETTE = ["#c9a227","#00b4d8","#ef4444","#22c55e","#f97316","#8b5cf6","#ec4899","#ffffff","#111111","#06b6d4"];

const FONT_STYLES = [
  { id:"impact",   label:__elakayText("t099", "Block"),   css:"'Impact','Arial Black',sans-serif" },
  { id:"bebas",    label:__elakayText("t100", "Bebas"),   css:"'Bebas Neue',sans-serif" },
  { id:"georgia",  label:__elakayText("t095", "Serif"),   css:"Georgia,serif" },
  { id:"courier",  label:__elakayText("t101", "Mono"),    css:"'Courier New',monospace" },
  { id:"treb",     label:__elakayText("t102", "Sans"),    css:"'Trebuchet MS',sans-serif" },
  { id:"palatino", label:__elakayText("t103", "Italic"),  css:"'Palatino Linotype',serif" },
];

const ARTISTIC_STYLES = [__elakayText("t104", "Street Art"),__elakayText("t105", "Bubble"),__elakayText("t106", "Wildstyle"),__elakayText("t107", "Calligraphy"),__elakayText("t108", "Minimalist"),__elakayText("t109", "Vintage"),__elakayText("t110", "Neon"),__elakayText("t111", "Abstract"),__elakayText("t112", "Cartoon"),__elakayText("t113", "Gothic")];
const DETAIL_LEVELS   = [__elakayText("t114", "Simple"),__elakayText("t115", "Moderate"),__elakayText("t116", "Detailed"),__elakayText("t117", "Hyper-detailed")];

const QUICK_POS = [
  {label:"↖",x:12,y:12},{label:"↑",x:50,y:12},{label:"↗",x:88,y:12},
  {label:"←",x:12,y:50},{label:"·",x:50,y:50},{label:"→",x:88,y:50},
  {label:"↙",x:12,y:88},{label:"↓",x:50,y:88},{label:"↘",x:88,y:88},
];

const makeTextBlock = (role = "Text", overrides = {}) => ({
  role, content:"TEXT", fontId:"impact", size:56,
  color:"#c9a227", outlineColor:"#000000", outlineWidth:2,
  shadowEnabled:false, shadowColor:"#000000",
  gradient:false, gradColor:"#007399",
  textTransform:"uppercase", letterSpacing:0,
  rotation:0, opacity:100, pos:{x:50,y:35},
  ...overrides,
});

const makeSlotDesign = () => ({
  texts: [], layers: [], zoom: 1, pan: {x:0,y:0}, instructions: "",
});

/* 🆕 Factory : crée un nouveau slot vide */
const makeNewSlot = (existingCount = 0) => ({
  id: `s${Date.now()}_${Math.random().toString(36).slice(2, 7)}`,
  label: `Face ${existingCount + 1}`,
  url: "",
  localUrl: ""
});

/* ══════════════════════════════════════════════════════
   DesignCanvas_
══════════════════════════════════════════════════════ */
function DesignCanvas({
  design, slotDef,
  onUpdateTextBlock, onUpdateLayer, onAddLayer, onSetActiveEl,
  activeEl, onZoomPan,
  readOnly = false,
  showTexts = true, showLayers = true,
  showLabel = false, showControls = true,
  dimFactor = 1, defaultMode = "all"
}) {

  const canvasRef  = useRef();
  const stageRef   = useRef();
  const posterRef  = useRef(null);
  const zRef       = useRef(1);
  const pRef       = useRef({ x: 0, y: 0 });
  const lastPinch  = useRef(null);
  const dragging   = useRef(null);
  const panning    = useRef(false);
  const dragOff    = useRef({ ox: 0, oy: 0 });
  const dragIdx    = useRef(null);
  const panStart   = useRef({ mx: 0, my: 0, px: 0, py: 0 });

  const [zoomDisplay, setZoomDisplay] = useState(1);
  const [showText, setShowText] = useState(true);
  const [mode, setMode] = useState(defaultMode);

  const { texts, layers, zoom, pan } = design;

  const effectiveShowBg     = mode === "all" || mode === "url";
  const effectiveShowTexts  = showTexts  && (mode === "all" || mode === "elements");
  const effectiveShowLayers = showLayers && (mode === "all" || mode === "elements");

  useEffect(() => {
    if (zoom !== zRef.current) { zRef.current = zoom; setZoomDisplay(zoom); }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => { pRef.current = pan; }, [pan]);

  useEffect(() => {
    if (!slotDef?.url && !slotDef?.localUrl) {
      posterRef.current = null;
      draw();
      return;
    }
    const img = new Image();
    img.crossOrigin = "anonymous";
    img.onload = () => { posterRef.current = img; draw(); };
    img.onerror = () => console.warn("Bg failed:", slotDef.url || slotDef.localUrl);
    img.src = slotDef.localUrl || toImageUrl(slotDef.url);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [slotDef?.url, slotDef?.localUrl, zoom, pan]);

  useEffect(() => {
    layers.forEach((layer, idx) => {
      if (layer.imgEl) return;
      const url = toImageUrl(layer.urlImg || layer.url || layer.src || "");
      if (!url) return;
      const img = new Image();
      img.crossOrigin = "anonymous";
      img.onload  = () => onUpdateLayer(idx, { imgEl: img });
      img.onerror = () => console.warn(`Layer ${idx} failed:`, url);
      img.src = url;
    });
  }, [layers, onUpdateLayer]);

  const draw = useCallback(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext("2d");
    const W = canvas.width;
    const H = canvas.height;

    ctx.clearRect(0, 0, W, H);
    const z = zRef.current;
    const px = pRef.current.x;
    const py = pRef.current.y;

    ctx.save();
    ctx.translate(px, py);
    ctx.scale(z, z);

    if (effectiveShowBg && posterRef.current) {
      const pr = posterRef.current;
      const sc = Math.max(W / pr.naturalWidth, H / pr.naturalHeight);
      const sw = pr.naturalWidth * sc;
      const sh = pr.naturalHeight * sc;
      ctx.save();
      ctx.filter = `brightness(${dimFactor})`;
      ctx.drawImage(pr, (W - sw) / 2, (H - sh) / 2, sw, sh);
      ctx.restore();
    } else if (effectiveShowBg && !posterRef.current) {
      ctx.fillStyle = "#171c2a";
      ctx.fillRect(0, 0, W, H);
      ctx.font = `600 12px 'DM Sans',sans-serif`;
      ctx.textAlign = "center";
      ctx.textBaseline = "middle";
      ctx.fillStyle = "rgba(122,132,153,.45)";
      ctx.fillText(slotDef?.label || "No image", W / 2, H / 2 - 10);
      ctx.font = `400 10px 'DM Sans',sans-serif`;
      ctx.fillText("Click ✏️ to add an image", W / 2, H / 2 + 10);
    } else if (!effectiveShowBg) {
      const tile = Math.max(8, W / 60);
      ctx.fillStyle = "#1a1f2e";
      ctx.fillRect(0, 0, W, H);
      ctx.fillStyle = "#222838";
      for (let y = 0; y < H; y += tile) {
        for (let x = 0; x < W; x += tile) {
          if (((x / tile) + (y / tile)) % 2 === 0) ctx.fillRect(x, y, tile, tile);
        }
      }
    }

    if (effectiveShowLayers) {
      layers.forEach((layer, idx) => {
        if (!layer.imgEl) return;
        const ratio = layer.imgEl.naturalHeight / layer.imgEl.naturalWidth;
        const lW = Math.round(W * (layer.size / 100));
        const lH = Math.round(ratio * lW);
        const cx = (layer.pos.x / 100) * W;
        const cy = (layer.pos.y / 100) * H;

        ctx.save();
        ctx.globalAlpha = layer.opacity / 100;
        ctx.translate(cx, cy);
        ctx.rotate((layer.rotation * Math.PI) / 180);
        ctx.shadowColor = "rgba(0,0,0,.35)";
        ctx.shadowBlur = 12 / z;
        ctx.drawImage(layer.imgEl, -lW / 2, -lH / 2, lW, lH);
        ctx.shadowBlur = 0;

        if (!readOnly && activeEl === `img:${idx}`) {
          ctx.strokeStyle = "#00b4d8";
          ctx.lineWidth = Math.max(2, W * 0.003) / z;
          ctx.setLineDash([6, 3]);
          ctx.strokeRect(-lW / 2 - 4, -lH / 2 - 4, lW + 8, lH + 8);
          ctx.setLineDash([]);
          const hw = 6 / z;
          [[-lW/2-4, -lH/2-4], [lW/2+4, -lH/2-4], [lW/2+4, lH/2+4], [-lW/2-4, lH/2+4]].forEach(([cx2, cy2]) => {
            ctx.fillStyle = "#00b4d8";
            ctx.fillRect(cx2 - hw, cy2 - hw, hw * 2, hw * 2);
          });
        }
        ctx.restore();
      });
    }

    if (effectiveShowTexts && showText) {
      texts.forEach((tb, idx) => {
        const fontDef = FONT_STYLES.find(f => f.id === tb.fontId) || FONT_STYLES[0];
        const fs = Math.round(tb.size * (W / 540));
        const tx = (tb.pos.x / 100) * W;
        const ty = (tb.pos.y / 100) * H;

        const applyCase = s =>
          tb.textTransform === "uppercase" ? s.toUpperCase()
          : tb.textTransform === "lowercase" ? s.toLowerCase()
          : s;
        const line = applyCase(tb.content || "");

        ctx.save();
        ctx.translate(tx, ty);
        ctx.rotate((tb.rotation * Math.PI) / 180);
        ctx.globalAlpha = tb.opacity / 100;
        ctx.font = `900 ${fs}px ${fontDef.css}`;
        ctx.textAlign = "center";
        ctx.textBaseline = "middle";

        if (tb.shadowEnabled) {
          ctx.shadowColor = tb.shadowColor;
          ctx.shadowBlur = fs * 0.12;
          ctx.shadowOffsetX = fs * 0.04;
          ctx.shadowOffsetY = fs * 0.04;
        }

        if (tb.gradient) {
          const grad = ctx.createLinearGradient(-W * 0.3, 0, W * 0.3, 0);
          grad.addColorStop(0, tb.color);
          grad.addColorStop(1, tb.gradColor);
          ctx.fillStyle = grad;
        } else {
          ctx.fillStyle = tb.color;
        }

        ctx.fillText(line, 0, 0);

        if (tb.outlineWidth > 0) {
          ctx.shadowBlur = 0;
          ctx.shadowColor = "transparent";
          ctx.strokeStyle = tb.outlineColor;
          ctx.lineWidth = tb.outlineWidth;
          ctx.strokeText(line, 0, 0);
        }

        if (!readOnly && activeEl === `text:${idx}`) {
          ctx.shadowBlur = 0;
          ctx.shadowColor = "transparent";
          const bw = Math.max(line.length, 1) * fs * 0.58 + 14;
          const bh = fs * 1.1 + 10;
          ctx.strokeStyle = "#c9a227";
          ctx.lineWidth = Math.max(1.5, W * 0.003) / z;
          ctx.setLineDash([5, 3]);
          ctx.strokeRect(-bw / 2, -bh / 2, bw, bh);
          ctx.setLineDash([]);
        }
        ctx.restore();
      });
    }

    ctx.restore();

    if (showLabel && slotDef?.label) {
      const lh = Math.max(24, H * 0.06);
      const grad = ctx.createLinearGradient(0, H - lh, 0, H);
      grad.addColorStop(0, "rgba(0,0,0,0)");
      grad.addColorStop(1, "rgba(0,0,0,0.7)");
      ctx.fillStyle = grad;
      ctx.fillRect(0, H - lh, W, lh);
      ctx.font = `600 ${Math.max(11, W / 50)}px 'DM Sans',sans-serif`;
      ctx.fillStyle = "#fff";
      ctx.textAlign = "center";
      ctx.textBaseline = "middle";
      ctx.fillText(slotDef.label, W / 2, H - lh / 2);
    }
  }, [texts, layers, activeEl, slotDef, showText, readOnly,
      effectiveShowBg, effectiveShowTexts, effectiveShowLayers,
      dimFactor, showLabel]);

  const hasBg = !!(slotDef?.url || slotDef?.localUrl);
  const hasElements = texts.length > 0 || layers.length > 0;

  const MODES = useMemo(() => [
    { id: "all",      label: __elakayText("t118", "All"),        icon: "🎨", disabled: !hasBg && !hasElements },
    { id: "url",      label: __elakayText("t119", "Background"), icon: "🖼️", disabled: !hasBg },
    { id: "elements", label: __elakayText("t120", "Elements"),   icon: "✏️", disabled: !hasElements }
  ], [hasBg, hasElements]);

  useEffect(() => {
    const current = MODES.find(m => m.id === mode);
    if (current?.disabled) {
      const firstAvailable = MODES.find(m => !m.disabled);
      if (firstAvailable) setMode(firstAvailable.id);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hasBg, hasElements]);

  useEffect(() => { draw(); }, [draw]);


useEffect(() => {
  let rafId = null;

  const fit = () => {
    if (rafId) cancelAnimationFrame(rafId);

    rafId = requestAnimationFrame(() => {
      const canvas = canvasRef.current;
      const stage = stageRef.current;
      if (!canvas || !stage) return;

      const W = Math.round(stage.clientWidth || 500);
      const H = Math.round(
        W *
          (posterRef.current
            ? posterRef.current.naturalHeight / posterRef.current.naturalWidth
            : 1.2)
      );

      // Important: ne change pas la taille si elle est déjà correcte
      if (canvas.width !== W || canvas.height !== H) {
        canvas.width = W;
        canvas.height = H;
      }

      draw();
    });
  };

  fit();

  const ro = new ResizeObserver(() => {
    fit();
  });

  if (stageRef.current) {
    ro.observe(stageRef.current);
  }

  return () => {
    if (rafId) cancelAnimationFrame(rafId);
    ro.disconnect();
  };
}, [draw]);

  const toLogical = (e) => {
    const canvas = canvasRef.current;
    const rect = canvas.getBoundingClientRect();
    const t = e.touches?.[0] ?? e;
    const rx = (t.clientX - rect.left) * (canvas.width / rect.width);
    const ry = (t.clientY - rect.top) * (canvas.height / rect.height);
    return {
      x: (rx - pRef.current.x) / zRef.current,
      y: (ry - pRef.current.y) / zRef.current,
      rx, ry
    };
  };

  const overText = (lx, ly, tb) => {
    const canvas = canvasRef.current;
    if (!canvas) return false;
    const W = canvas.width;
    const tx = (tb.pos.x / 100) * W;
    const ty = (tb.pos.y / 100) * canvas.height;
    const fs = Math.round(tb.size * (W / 540));
    const hw = Math.max(tb.content.length, 1) * fs * 0.35 + 10;
    const hh = fs * 0.6 + 7;
    const rad = -(tb.rotation * Math.PI) / 180;
    const dx = lx - tx;
    const dy = ly - ty;
    const rx = dx * Math.cos(rad) - dy * Math.sin(rad);
    const ry = dx * Math.sin(rad) + dy * Math.cos(rad);
    return Math.abs(rx) <= hw && Math.abs(ry) <= hh;
  };

  const layerAt = (lx, ly) => {
    const canvas = canvasRef.current;
    if (!canvas) return -1;
    const W = canvas.width;
    const H = canvas.height;
    for (let i = layers.length - 1; i >= 0; i--) {
      const layer = layers[i];
      if (!layer.imgEl) continue;
      const ratio = layer.imgEl.naturalHeight / layer.imgEl.naturalWidth;
      const lW = Math.round(W * (layer.size / 100));
      const lH = Math.round(ratio * lW);
      const cx = (layer.pos.x / 100) * W;
      const cy = (layer.pos.y / 100) * H;
      const rad = -(layer.rotation * Math.PI) / 180;
      const dx = lx - cx;
      const dy = ly - cy;
      const rx = dx * Math.cos(rad) - dy * Math.sin(rad);
      const ry = dx * Math.sin(rad) + dy * Math.cos(rad);
      if (Math.abs(rx) <= lW / 2 + 10 && Math.abs(ry) <= lH / 2 + 10) return i;
    }
    return -1;
  };

  const clampZoom = (z) => Math.min(5, Math.max(1, z));

  const clampPan = (px, py, z, canvas) => ({
    x: Math.min(0, Math.max(-canvas.width  * (z - 1), px)),
    y: Math.min(0, Math.max(-canvas.height * (z - 1), py))
  });

  const handlePointerDown = useCallback((e) => {
    if (e.touches?.length === 2) return;
    const { x, y, rx, ry } = toLogical(e);
    const canvas = canvasRef.current;
    if (!canvas) return;
    const W = canvas.width;
    const H = canvas.height;

    if (readOnly) {
      if (zRef.current > 1) {
        e.preventDefault();
        panStart.current = { mx: rx, my: ry, px: pRef.current.x, py: pRef.current.y };
        panning.current = true;
      }
      return;
    }

    const hitImg = layerAt(x, y);
    if (hitImg >= 0) {
      e.preventDefault();
      onSetActiveEl(`img:${hitImg}`);
      dragIdx.current = hitImg;
      dragging.current = "img";
      dragOff.current = {
        ox: x - (layers[hitImg].pos.x / 100) * W,
        oy: y - (layers[hitImg].pos.y / 100) * H
      };
      return;
    }

    for (let i = texts.length - 1; i >= 0; i--) {
      if (overText(x, y, texts[i])) {
        e.preventDefault();
        onSetActiveEl(`text:${i}`);
        dragIdx.current = i;
        dragging.current = "text";
        dragOff.current = {
          ox: x - (texts[i].pos.x / 100) * W,
          oy: y - (texts[i].pos.y / 100) * H
        };
        return;
      }
    }

    if (zRef.current > 1) {
      e.preventDefault();
      panStart.current = { mx: rx, my: ry, px: pRef.current.x, py: pRef.current.y };
      panning.current = true;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [layers, texts, onSetActiveEl, readOnly]);

  const handlePointerMove = useCallback((e) => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const W = canvas.width;
    const H = canvas.height;

    if (readOnly) {
      if (panning.current) {
        e.preventDefault?.();
        const rect = canvas.getBoundingClientRect();
        const t2 = e.touches?.[0] ?? e;
        const rx = (t2.clientX - rect.left) * (W / rect.width);
        const ry = (t2.clientY - rect.top) * (canvas.height / rect.height);
        const clamped = clampPan(
          panStart.current.px + (rx - panStart.current.mx),
          panStart.current.py + (ry - panStart.current.my),
          zRef.current, canvas
        );
        pRef.current = clamped;
        onZoomPan(zRef.current, clamped);
      }
      return;
    }

    if (dragging.current === "img" && dragIdx.current !== null) {
      e.preventDefault?.();
      const { x, y } = toLogical(e);
      onUpdateLayer(dragIdx.current, {
        pos: {
          x: Math.min(100, Math.max(0, ((x - dragOff.current.ox) / W) * 100)),
          y: Math.min(100, Math.max(0, ((y - dragOff.current.oy) / H) * 100))
        }
      });
      return;
    }

    if (dragging.current === "text" && dragIdx.current !== null) {
      e.preventDefault?.();
      const { x, y } = toLogical(e);
      onUpdateTextBlock(dragIdx.current, "pos", {
        x: Math.min(100, Math.max(0, ((x - dragOff.current.ox) / W) * 100)),
        y: Math.min(100, Math.max(0, ((y - dragOff.current.oy) / H) * 100))
      });
      return;
    }

    if (panning.current) {
      e.preventDefault?.();
      const rect = canvas.getBoundingClientRect();
      const t2 = e.touches?.[0] ?? e;
      const rx = (t2.clientX - rect.left) * (W / rect.width);
      const ry = (t2.clientY - rect.top) * (canvas.height / rect.height);
      const clamped = clampPan(
        panStart.current.px + (rx - panStart.current.mx),
        panStart.current.py + (ry - panStart.current.my),
        zRef.current, canvas
      );
      pRef.current = clamped;
      onZoomPan(zRef.current, clamped);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [layers, texts, onUpdateLayer, onUpdateTextBlock, onZoomPan, readOnly]);

  const handlePointerUp = useCallback(() => {
    dragging.current = null;
    panning.current = false;
    dragIdx.current = null;
  }, []);

  const handleCursorMove = useCallback((e) => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    if (dragging.current) { canvas.style.cursor = "grabbing"; return; }
    if (readOnly) {
      canvas.style.cursor = zRef.current > 1
        ? (panning.current ? "grabbing" : "grab") : "default";
      return;
    }
    const { x, y } = toLogical(e);
    if (layerAt(x, y) >= 0) { canvas.style.cursor = "grab"; return; }
    for (let i = texts.length - 1; i >= 0; i--) {
      if (overText(x, y, texts[i])) { canvas.style.cursor = "grab"; return; }
    }
    canvas.style.cursor = zRef.current > 1 ? "zoom-out" : "zoom-in";
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [layers, texts, zoomDisplay, pan, readOnly]);

  useEffect(() => {
    window.addEventListener("mousemove", handlePointerMove);
    window.addEventListener("mouseup", handlePointerUp);
    return () => {
      window.removeEventListener("mousemove", handlePointerMove);
      window.removeEventListener("mouseup", handlePointerUp);
    };
  }, [handlePointerMove, handlePointerUp]);

  const applyZoom = (newZ, mx, my) => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const z2 = clampZoom(newZ);
    const clamped = clampPan(
      mx - (mx - pRef.current.x) * (z2 / zRef.current),
      my - (my - pRef.current.y) * (z2 / zRef.current),
      z2, canvas
    );
    zRef.current = z2;
    pRef.current = clamped;
    setZoomDisplay(z2);
    onZoomPan(z2, clamped);
  };

  const resetZoom = () => {
    zRef.current = 1; pRef.current = { x: 0, y: 0 };
    setZoomDisplay(1); onZoomPan(1, { x: 0, y: 0 });
  };

  const stepZoom = (dir) => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    applyZoom(zRef.current + dir * 0.3 * zRef.current, canvas.width / 2, canvas.height / 2);
  };

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;

    const onWheel = (e) => {
      e.preventDefault();
      const rect = canvas.getBoundingClientRect();
      const W = canvas.width;
      applyZoom(
        zRef.current + (e.deltaY > 0 ? -0.15 : 0.15) * zRef.current,
        (e.clientX - rect.left) * (W / rect.width),
        (e.clientY - rect.top) * (canvas.height / rect.height)
      );
    };

    const onTZ = (e) => {
      if (e.touches.length !== 2) return;
      e.preventDefault();
      const t1 = e.touches[0]; const t2 = e.touches[1];
      const dist = Math.hypot(t2.clientX - t1.clientX, t2.clientY - t1.clientY);
      const rect = canvas.getBoundingClientRect();
      const W = canvas.width;
      const mx = ((t1.clientX + t2.clientX) / 2 - rect.left) * (W / rect.width);
      const my = ((t1.clientY + t2.clientY) / 2 - rect.top) * (canvas.height / rect.height);
      if (lastPinch.current) applyZoom(zRef.current * (dist / lastPinch.current), mx, my);
      lastPinch.current = dist;
    };

    canvas.addEventListener("wheel", onWheel, { passive: false });
    canvas.addEventListener("touchmove", onTZ, { passive: false });
    canvas.addEventListener("touchend", () => { lastPinch.current = null; });

    return () => {
      canvas.removeEventListener("wheel", onWheel);
      canvas.removeEventListener("touchmove", onTZ);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleDownload = () => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const safeName = slotDef?.label?.toLowerCase().replace(/\s+/g, "-") || "canvas";
    const link = document.createElement("a");
    link.download = `elakay-design-${safeName}.png`;
    link.href = canvas.toDataURL("image/png", 1.0);
    link.click();
  };

  const fileRef = useRef();

  const addImgLayer = async (file) => {
    if (!file?.type.startsWith("image/")) return;
    const imgEl = await new Promise((res, rej) => {
      const img = new Image();
      img.onload = () => res(img);
      img.onerror = rej;
      img.src = URL.createObjectURL(file);
    });
    onAddLayer({
      src: URL.createObjectURL(file),
      imgEl, file,
      pos: {
        x: 25 + (layers.length % 3) * 20,
        y: 55 + Math.floor(layers.length / 3) * 20
      },
      size: 25, rotation: 0, opacity: 100
    });
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", height: "100%", minHeight: 0 }}>

      <div className="sd-zbar">
        <button type="button" className="sd-zbtn" onClick={() => stepZoom(-1)} disabled={zoomDisplay <= 1}>−</button>
        <input type="range" min={1} max={5} step={0.05} value={zoomDisplay}
          style={{ flex: 1, accentColor: "var(--teal)" }}
          onChange={e => {
            const canvas = canvasRef.current;
            if (!canvas) return;
            applyZoom(+e.target.value, canvas.width / 2, canvas.height / 2);
          }}/>
        <button type="button" className="sd-zbtn" onClick={() => stepZoom(1)} disabled={zoomDisplay >= 5}>+</button>
        <span className="sd-zpct">{Math.round(zoomDisplay * 100)}%</span>
        {zoomDisplay > 1 && <button type="button" className="sd-zreset" onClick={resetZoom}>↺</button>}

        <button type="button"
          className={`sd-toggle-text${showText ? "" : " off"}`}
          onClick={() => setShowText(v => !v)}
          title={showText ? elakayAutoText("h_9b9694099ca78b", "Hide texts") : elakayAutoText("h_d263a316b97ab0", "Show texts")}>
          {showText ? elakayAutoText("h_e95d52efc11364", "𝐓 Text ON") : elakayAutoText("h_e0b5bc42675bdc", "𝐓̶ Text OFF")}
        </button>

        <button type="button" className="sd-dl-btn" onClick={handleDownload} title={__elakayText("t033", "Download PNG")}>{__elakayText("t082", "↓ PNG")}</button>

        {!readOnly && (
          <>
            <button type="button" className="sd-btn sd-btn-ghost"
              style={{ padding: "2px 8px", fontSize: 9.5 }}
              onClick={() => fileRef.current?.click()}>{__elakayText("t083", "+ Image")}</button>
            <input ref={fileRef} type="file" accept="image/*" style={{ display: "none" }}
              onChange={e => { addImgLayer(e.target.files[0]); e.target.value = ""; }}/>
          </>
        )}
      </div>

      <div ref={stageRef} className="sd-stage" style={{ position: "relative" }}>
        <canvas ref={canvasRef} className="sd-canvas"
          onMouseDown={handlePointerDown}
          onMouseMove={handleCursorMove}
          onTouchStart={e => { if (e.touches.length === 1) handlePointerDown(e); }}
          onTouchMove={e => { if (e.touches.length === 1) handlePointerMove(e); }}
          onTouchEnd={handlePointerUp}/>

        {showControls && (
          <div style={{
            position: "absolute", bottom: 12,
            left: "50%", transform: "translateX(-50%)",
            zIndex: 20, display: "flex", gap: 2, padding: 3,
            background: "rgba(10,15,28,.85)", borderRadius: 18,
            backdropFilter: "blur(8px)", WebkitBackdropFilter: "blur(8px)",
            boxShadow: "0 2px 10px rgba(0,0,0,.3)",
            border: "1px solid rgba(255,255,255,.1)"
          }}>
            {MODES.map(m => (
              <button key={m.id} type="button"
                onClick={e => { e.stopPropagation(); e.preventDefault(); if (!m.disabled) setMode(m.id); }}
                disabled={m.disabled} title={m.label}
                style={{
                  padding: "5px 10px", borderRadius: 14, border: "none",
                  background: mode === m.id
                    ? "linear-gradient(135deg, #007399, #00a4d8)"
                    : "transparent",
                  color: mode === m.id ? "#fff" : "rgba(255,255,255,.65)",
                  fontSize: 10, fontWeight: 700, fontFamily: "var(--ffb)",
                  cursor: m.disabled ? "not-allowed" : "pointer",
                  opacity: m.disabled ? 0.35 : 1, transition: "all .15s",
                  display: "flex", alignItems: "center", gap: 4,
                  letterSpacing: 0.3, textTransform: "uppercase",
                  whiteSpace: "nowrap",
                  boxShadow: mode === m.id ? "0 2px 8px rgba(0,115,153,.4)" : "none"
                }}>
                <span>{m.icon}</span><span>{m.label}</span>
              </button>
            ))}
          </div>
        )}
      </div>

      <div className="sd-chint">
        {readOnly
          ? elakayAutoText("h_6e3236fde176d9", "Scroll/pinch = zoom · Drag (when zoomed) = pan")
          : elakayAutoText("h_f71a12549b3a9d", "Scroll/pinch = zoom · Drag text or image = move · Buttons = precise control")}
      </div>
    </div>
  );
}

/* ══════════════════════════════════════════════════════
   DesignControls
══════════════════════════════════════════════════════ */
function DesignControls({
  design, onUpdateTextBlock, onAddTextBlock, onRemoveTextBlock,
  onUpdateLayer, onAddLayer, onRemoveLayer,
  onSetActiveEl, activeEl, onUpdateInstructions, infoSource
}) {
  const text = (key, fallback) => getHardcodedText(infoSource, "designStudio", key, fallback);
  const { texts, layers } = design;
  const selKind = activeEl?.split(":")[0];
  const selIdx  = activeEl ? parseInt(activeEl.split(":")[1]) : null;
  const activeTb  = selKind==="text" && selIdx!=null ? texts[selIdx] : null;
  const activeImg = selKind==="img"  && selIdx!=null ? layers[selIdx]: null;
  const fileRef=useRef();

  const setTb=(k,v)=>{ if(selIdx==null) return; onUpdateTextBlock(selIdx,k,v); };

  const addImgLayer=async file=>{
    if(!file?.type.startsWith("image/")) return;
    if(layers.length>=6) return;
    const imgEl=await new Promise((res,rej)=>{
      const img=new Image();
      img.onload=()=>res(img);
      img.onerror=rej;
      img.src=URL.createObjectURL(file);
    });
    onAddLayer({
      src:URL.createObjectURL(file),imgEl,file,
      pos:{x:25+(layers.length%3)*20,y:55+Math.floor(layers.length/3)*20},
      size:25,rotation:0,opacity:100
    });
  };

  const Slider=({label,value,min,max,step=1,unit="",onChange,presets=[]})=>(
    <div className="sd-field2">
      <div style={{display:"flex",justifyContent:"space-between"}}>
        <span className="sd-lbl2">{label}</span>
        <span className="sd-sval">{value}{unit}</span>
      </div>
      <div className="sd-srow">
        <input type="range" className="sd-slider" min={min} max={max} step={step} value={value}
          onChange={e=>onChange(+e.target.value)}/>
      </div>
      {presets.length>0&&(
        <div className="sd-presets">
          {presets.map(p=>
            <button key={p} type="button"
              className={`sd-chip sd-chip-sm${value===p?" on":""}`}
              onClick={e=>{e.preventDefault();onChange(p);}}>
              {p}{unit}
            </button>
          )}
        </div>
      )}
    </div>
  );

  const ColorRow=({label,value,onChange})=>(
    <div className="sd-field2">
      <span className="sd-lbl2">{label}</span>
      <div className="sd-colors">
        {PALETTE.map(c=>
          <button key={c} type="button"
            className={`sd-sw${value===c?" on":""}`}
            style={{background:c}}
            onClick={()=>onChange(c)}/>
        )}
        <input type="color" className="sd-cpick" value={value} onChange={e=>onChange(e.target.value)}/>
      </div>
    </div>
  );

  const QuickPos = ({ pos, onPos, step = 0.5 }) => {
    const handleClick = (p) => {
      if (p.x === 50 && p.y === 50) { onPos({ x: 50, y: 50 }); return; }
      const dx = Math.sign(p.x - 50) * step;
      const dy = Math.sign(p.y - 50) * step;
      const cx = pos?.x ?? 50;
      const cy = pos?.y ?? 50;
      const nx = Math.min(100, Math.max(0, cx + dx));
      const ny = Math.min(100, Math.max(0, cy + dy));
      onPos({ x: Math.round(nx * 10) / 10, y: Math.round(ny * 10) / 10 });
    };

    const isDisabled = (p) => {
      if (p.x === 50 && p.y === 50) return false;
      const dx = Math.sign(p.x - 50) * step;
      const dy = Math.sign(p.y - 50) * step;
      const cx = pos?.x ?? 50;
      const cy = pos?.y ?? 50;
      const blockedX = (dx < 0 && cx <= 0) || (dx > 0 && cx >= 100);
      const blockedY = (dy < 0 && cy <= 0) || (dy > 0 && cy >= 100);
      if (dx !== 0 && dy !== 0) return blockedX && blockedY;
      if (dx !== 0) return blockedX;
      if (dy !== 0) return blockedY;
      return false;
    };

    return (
      <div className="sd-field2">
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
          <span className="sd-lbl2">{__elakayText("t084", "Fine Position (±")}{step}%)</span>
          <span style={{
            fontSize: 9, fontFamily: "var(--ffm)",
            color: "var(--gold)", opacity: 0.85
          }}>
            {(pos?.x ?? 50).toFixed(1)}, {(pos?.y ?? 50).toFixed(1)}
          </span>
        </div>
        <div className="sd-qgrid">
          {QUICK_POS.map(p => {
            const disabled = isDisabled(p);
            return (
              <button key={p.label} type="button" className="sd-qbtn"
                disabled={disabled}
                style={{ opacity: disabled ? 0.3 : 1, cursor: disabled ? "not-allowed" : "pointer" }}
                title={p.x === 50 && p.y === 50 ? elakayAutoText("h_3f0bd5839d599f", "Center to 50%, 50%") : `Move ${p.label}`}
                onClick={e => { e.preventDefault(); handleClick(p); }}>
                {p.label}
              </button>
            );
          })}
        </div>
      </div>
    );
  };

  return(
    <div className="sd-panel">
      <div className="sd-sec">
        <div style={{display:"flex",alignItems:"center",justifyContent:"space-between"}}>
          <span className="sd-stitle">✏️ {text("t034", "Texts")}</span>
          <button type="button" className="sd-btn sd-btn-ghost" style={{padding:"3px 9px",fontSize:9.5}}
            onClick={e=>{
              e.preventDefault();
              const i=texts.length;
              onAddTextBlock(makeTextBlock(`Text ${i+1}`,{content:"NEW",color:"#ffffff",pos:{x:50,y:50}}));
              onSetActiveEl(`text:${i}`);
            }}>{__elakayText("t085", "+ Add")}</button>
        </div>
        <div className="sd-block-row">
          {texts.map((tb,i)=>(
            <div key={i} className={`sd-block-thumb${activeEl===`text:${i}`?" on":""}`}
              onClick={e=>{e.preventDefault();onSetActiveEl(`text:${i}`);}}>
              <span style={{fontSize:10,fontWeight:700,color:tb.color,fontFamily:"Impact,sans-serif"}}>
                {(tb.content||"T").slice(0,3).toUpperCase()}
              </span>
              <span className="sd-block-lbl">{tb.role}</span>
              <button type="button" className="sd-block-rm"
                onClick={e=>{
                  e.stopPropagation(); e.preventDefault();
                  onRemoveTextBlock(i);
                  if(activeEl===`text:${i}`) onSetActiveEl(null);
                }}>✕</button>
            </div>
          ))}
        </div>

        {activeTb&&(
          <div className="sd-edit-panel">
            <span className="sd-ep-title gold">✏️ {activeTb.role}</span>
            <div className="sd-field2">
              <label className="sd-lbl2">{text("t035", "Role")}</label>
              <input className="sd-input2" value={activeTb.role}
                onChange={e=>setTb("role",e.target.value)} placeholder={text("t036", "Brand, Title...")}/>
            </div>
            <div className="sd-field2">
              <label className="sd-lbl2">{text("t037", "Content *")}</label>
              <div className="sd-cw">
                <input className="sd-input2" maxLength={24} value={activeTb.content}
                  onChange={e=>setTb("content",e.target.value)} placeholder={text("t038", "TEXT")}/>
                <span className="sd-cc">{activeTb.content.length}/24</span>
              </div>
            </div>
            <div className="sd-field2">
              <span className="sd-lbl2">{text("t039", "Font")}</span>
              <div className="sd-chips">
                {FONT_STYLES.map(f=>
                  <button key={f.id} type="button"
                    className={`sd-chip${activeTb.fontId===f.id?" on":""}`}
                    style={{fontFamily:f.css}}
                    onClick={e=>{e.preventDefault();setTb("fontId",f.id);}}>
                    {f.label}
                  </button>
                )}
              </div>
            </div>
            <div className="sd-field2">
              <span className="sd-lbl2">{text("t040", "Case")}</span>
              <div className="sd-chips">
                {[["uppercase","AAA"],["lowercase","aaa"],["none","Aa"]].map(([v,l])=>
                  <button key={v} type="button"
                    className={`sd-chip${activeTb.textTransform===v?" on":""}`}
                    onClick={e=>{e.preventDefault();setTb("textTransform",v);}}>
                    {l}
                  </button>
                )}
              </div>
            </div>
            <Slider label={text("t041", "Size")} value={activeTb.size} min={8} max={160} step={2} unit="px"
              onChange={v=>setTb("size",v)} presets={[16,24,48,72,96,128]}/>
            <Slider label={text("t042", "Rotation")} value={activeTb.rotation} min={-180} max={180} unit="°"
              onChange={v=>setTb("rotation",v)} presets={[-90,-45,0,45,90]}/>
            <Slider label={text("t043", "Spacing")} value={activeTb.letterSpacing} min={-5} max={20} unit="px"
              onChange={v=>setTb("letterSpacing",v)}/>
            <Slider label={text("t044", "Opacity")} value={activeTb.opacity} min={5} max={100} unit="%"
              onChange={v=>setTb("opacity",v)}/>
            <div className="sd-r2b">
              <Slider label={__elakayText("t086", "← X →")} value={Math.round(activeTb.pos.x)} min={0} max={100} step={.5} unit="%"
                onChange={v=>setTb("pos",{...activeTb.pos,x:v})}/>
              <Slider label={__elakayText("t087", "↑ Y ↓")} value={Math.round(activeTb.pos.y)} min={0} max={100} step={.5} unit="%"
                onChange={v=>setTb("pos",{...activeTb.pos,y:v})}/>
            </div>
            <QuickPos pos={activeTb.pos} onPos={pos => setTb("pos", pos)} />
            <ColorRow label={text("t047", "Main color")} value={activeTb.color} onChange={v=>setTb("color",v)}/>
            <ColorRow label={text("t048", "Outline color")} value={activeTb.outlineColor} onChange={v=>setTb("outlineColor",v)}/>
            <Slider label={text("t049", "Outline width")} value={activeTb.outlineWidth} min={0} max={8} step={.5} unit="px"
              onChange={v=>setTb("outlineWidth",v)}/>
            <div className="sd-field2">
              <span className="sd-lbl2">{text("t050", "Effects")}</span>
              <div className="sd-chips">
                {[["shadowEnabled","🌒 Shadow"],["gradient","🌈 Gradient"]].map(([k,l])=>
                  <button key={k} type="button"
                    className={`sd-chip${activeTb[k]?" on":""}`}
                    onClick={e=>{e.preventDefault();setTb(k,!activeTb[k]);}}>
                    {l}
                  </button>
                )}
              </div>
            </div>
            {activeTb.gradient&&
              <ColorRow label={text("t051", "Gradient color 2")} value={activeTb.gradColor} onChange={v=>setTb("gradColor",v)}/>
            }
          </div>
        )}
        {!activeTb&&selKind!=="img"&&
          <div className="sd-info" style={{fontSize:10}}>{__elakayText("t088", "👆 Click a text block to edit, or drag it on the canvas.")}</div>
        }
      </div>

      <div className="sd-sec">
        <span className="sd-stitle">{__elakayText("t089", "📁 Images (")}{layers.length}/6)</span>
        {layers.length>0&&(
          <div className="sd-block-row">
            {layers.map((layer,i)=>(
              <div key={i} className={`sd-block-thumb${activeEl===`img:${i}`?" img-on":""}`}
                onClick={e=>{e.preventDefault();onSetActiveEl(`img:${i}`);}}>
                🖼️<span className="sd-block-lbl">{__elakayText("t121", "Img")}{i+1}</span>
                <button type="button" className="sd-block-rm"
                  onClick={e=>{
                    e.stopPropagation(); e.preventDefault();
                    onRemoveLayer(i);
                    if(activeEl===`img:${i}`) onSetActiveEl(null);
                  }}>✕</button>
              </div>
            ))}
          </div>
        )}
        {layers.length<6&&(
          <div className="sd-drop"
            onClick={e=>{e.stopPropagation();fileRef.current?.click();}}
            onDrop={e=>{e.preventDefault();addImgLayer(e.dataTransfer.files[0]);}}
            onDragOver={e=>e.preventDefault()}>
            <span style={{fontSize:18}}>⬆️</span>
            <span style={{fontSize:11,fontWeight:600,color:"var(--white)"}}>{text("t052", "Drag or click")}</span>
            <span style={{fontSize:9,color:"var(--muted)"}}>{__elakayText("t090", "PNG, JPG ·")}{layers.length}/6</span>
            <input ref={fileRef} type="file" accept="image/*" style={{display:"none"}}
              onChange={e=>{addImgLayer(e.target.files[0]);e.target.value="";}}/>
          </div>
        )}
        {activeImg && (
          <div className="sd-edit-panel">
            <span className="sd-ep-title gold">{__elakayText("t091", "🖼️ Image")}{selIdx + 1}</span>
            <Slider label={text("t053", "Size")} value={activeImg.size} min={5} max={90} unit="%"
              onChange={v => onUpdateLayer(selIdx, { size: v })}
              presets={[10, 20, 30, 50, 70]} />
            <Slider label={text("t054", "Rotation")} value={activeImg.rotation} min={-180} max={180} unit="°"
              onChange={v => onUpdateLayer(selIdx, { rotation: v })}
              presets={[-90, -45, 0, 45, 90]} />
            <Slider label={text("t055", "Opacity")} value={activeImg.opacity} min={5} max={100} unit="%"
              onChange={v => onUpdateLayer(selIdx, { opacity: v })}
              presets={[25, 50, 75, 100]} />
            <div className="sd-r2b">
              <Slider label={__elakayText("t086", "← X →")} value={Math.round(activeImg.pos.x * 10) / 10}
                min={0} max={100} step={0.5} unit="%"
                onChange={v => onUpdateLayer(selIdx, { pos: { ...activeImg.pos, x: v } })} />
              <Slider label={__elakayText("t087", "↑ Y ↓")} value={Math.round(activeImg.pos.y * 10) / 10}
                min={0} max={100} step={0.5} unit="%"
                onChange={v => onUpdateLayer(selIdx, { pos: { ...activeImg.pos, y: v } })} />
            </div>
            <QuickPos pos={activeImg.pos} onPos={pos => onUpdateLayer(selIdx, { pos })} />
          </div>
        )}
      </div>

      <div className="sd-sec">
        <span className="sd-stitle">📝 {text("t058", "Instructions")}</span>
        <div className="sd-field2">
          <label className="sd-lbl2">{text("t059", "Notes for this face")}</label>
          <textarea className="sd-ta2" rows={3} value={design.instructions}
            onChange={e=>onUpdateInstructions(e.target.value)}
            placeholder={text("t060", "Specific instructions for this product face...")}/>
        </div>
      </div>
    </div>
  );
}

/* ══════════════════════════════════════════════════════
   🆕 DesignStudio — avec gestion des faces intégrée
   - Bouton "+" (zone tabs)   → Ajouter une nouvelle face
   - Bouton "✏️" (zone tabs)  → Éditer la face sélectionnée
   - Bouton "🗑" (zone thumbs) → Supprimer la face sélectionnée
══════════════════════════════════════════════════════ */
export default function DesignStudio({
  infoSource,
   setActiveSlotId, 
   setPickerOpen,
  slots,
  setSlots,                 // 🆕 requis pour ajouter/éditer/supprimer
  onBack,
  onPublish,
  templateMeta,
  onMetaChange,
  onDesignsChange,
  initialDesigns = null,
  maxFaces = 8 ,             // 🆕 limite max
  open,
  ImageGallery, 
  images, 
  slotId 
}) {
  __setElakayInfoSource(infoSource);
  const text = (key, fallback) => getHardcodedText(infoSource, "designStudio", key, fallback);

  const [activeFace, setActiveFace] = useState(0);

  const [designs, setDesigns] = useState(() => {
    if (initialDesigns && initialDesigns.length === slots.length) return initialDesigns;
    return slots.map(() => makeSlotDesign());
  });

  const [activeEl, setActiveElState] = useState(() => slots.map(() => null));

  /* 🆕 États pour les modals de gestion des faces */
  const [editFaceOpen, setEditFaceOpen] = useState(false);
  const [confirmRemoveOpen, setConfirmRemoveOpen] = useState(false);

  const design  = designs[activeFace];
  const slotDef = slots[activeFace];

  useEffect(() => {
    if (initialDesigns &&
        initialDesigns.length > 0 &&
        initialDesigns.length === slots.length) {
      setDesigns(initialDesigns);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (onDesignsChange) onDesignsChange(designs);
  }, [designs, onDesignsChange]);

  /* 🆕 Sécurise activeFace si la liste change */
  useEffect(() => {
    if (activeFace >= slots.length && slots.length > 0) {
      setActiveFace(slots.length - 1);
    }
  }, [slots.length, activeFace]);

  const updTextBlock = (face, tbIdx, key, val) => {
    setDesigns(prev => {
      const n = [...prev];
      const texts = [...n[face].texts];
      texts[tbIdx] = { ...texts[tbIdx], [key]: val };
      n[face] = { ...n[face], texts };
      return n;
    });
  };

  const addTextBlock = (face, tb) => setDesigns(prev => {
    const n = [...prev];
    n[face] = { ...n[face], texts: [...n[face].texts, tb] };
    return n;
  });

  const rmTextBlock = (face, i) => setDesigns(prev => {
    const n = [...prev];
    n[face] = { ...n[face], texts: n[face].texts.filter((_, idx) => idx !== i) };
    return n;
  });

  const updLayer = (face, i, patch) => setDesigns(prev => {
    const n = [...prev];
    n[face] = { ...n[face], layers: n[face].layers.map((l, idx) => idx === i ? { ...l, ...patch } : l) };
    return n;
  });

  const addLayer = (face, layer) => setDesigns(prev => {
    const n = [...prev];
    n[face] = { ...n[face], layers: [...n[face].layers, layer] };
    return n;
  });

  const rmLayer = (face, i) => setDesigns(prev => {
    const n = [...prev];
    n[face] = { ...n[face], layers: n[face].layers.filter((_, idx) => idx !== i) };
    return n;
  });

  const setActiveEl = (face, el) => setActiveElState(prev => {
    const n = [...prev];
    n[face] = el;
    return n;
  });

  const updZoomPan = (face, z, p) => setDesigns(prev => {
    const n = [...prev];
    n[face] = { ...n[face], zoom: z, pan: p };
    return n;
  });

  const updInstr = (face, v) => setDesigns(prev => {
    const n = [...prev];
    n[face] = { ...n[face], instructions: v };
    return n;
  });

  /* 🐛 FIX: DesignCanvas passait un `onUpdateLayer` recréé (nouvelle
     identité de fonction) à chaque render de DesignStudio -- son effet de
     chargement des images de layers dépend de [layers, onUpdateLayer], donc
     il se relançait à CHAQUE render (pas seulement quand `layers` change
     vraiment), relançant le chargement des images pas encore prêtes
     (`!layer.imgEl`). Une fois une image chargée, `onUpdateLayer` déclenche
     un `setDesigns` -> re-render -> effet relancé -> nouvelle image chargée
     -> ... -- avec plusieurs layers en cache navigateur (résolution quasi
     synchrone), cette cascade peut dépasser la limite de renders imbriqués
     de React ("Maximum update depth exceeded"). Mémoïser sur `activeFace`
     seul (updLayer utilise déjà un `setDesigns(prev => ...)` fonctionnel,
     donc sa propre identité n'a pas besoin d'être dans les deps).
  */
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const handleUpdateLayerForCanvas = useCallback((i, p) => updLayer(activeFace, i, p), [activeFace]);

  /* ══════════════════════════════════════════════════════
     🆕 GESTION DES FACES — Add / Edit / Remove
  ══════════════════════════════════════════════════════ */

  /* Ajoute une nouvelle face vide */
  const handleAddFace = () => {
    if (!setSlots) {
      console.warn("DesignStudio: setSlots prop is required to add faces");
      return;
    }
    if (slots.length >= maxFaces) return;

    const newSlot = makeNewSlot(slots.length);

    /* Met à jour slots ET designs ET activeEl en parallèle */
    setSlots([...slots, newSlot]);
    setDesigns(prev => [...prev, makeSlotDesign()]);
    setActiveElState(prev => [...prev, null]);

    /* Sélectionne la nouvelle face */
    setActiveFace(slots.length);
  };

  /* Ouvre le modal d'édition pour la face active */
  const handleEditCurrentFace = () => {
    if (!setSlots || !slotDef) return;
    
    setEditFaceOpen(true);
  };

  /* Sauvegarde les modifs depuis le modal */
  const handleSaveFaceEdit = (patch) => {
    if (!setSlots) return;
    setSlots(slots.map((s, idx) =>
      idx === activeFace ? { ...s, ...patch } : s
    ));
  };

  /* Demande confirmation de suppression */
  const handleRequestRemoveFace = () => {
    if (!setSlots || slots.length <= 1) return;
    setConfirmRemoveOpen(true);
  };

  /* Supprime effectivement la face active */
  const handleConfirmRemoveFace = () => {
    if (!setSlots || slots.length <= 1) return;

    const removedIdx = activeFace;

    /* Supprime de slots */
    setSlots(slots.filter((_, idx) => idx !== removedIdx));

    /* Supprime du tableau designs */
    setDesigns(prev => prev.filter((_, idx) => idx !== removedIdx));

    /* Supprime de activeEl */
    setActiveElState(prev => prev.filter((_, idx) => idx !== removedIdx));

    /* Recale activeFace si on supprimait la dernière */
    if (removedIdx >= slots.length - 1) {
      setActiveFace(Math.max(0, slots.length - 2));
    }

    setConfirmRemoveOpen(false);
  };

  const hasMods = i => {
    const d = designs[i];
    return d && (d.texts.length > 0 || d.layers.length > 0 || d.instructions.length > 0);
  };

  const buildOutput = () => ({
    id: `g_${Date.now()}`,
    label: templateMeta.label || "My Template",
    style: templateMeta.style || "Street Art",
    detail: templateMeta.detail || "Moderate",
    slots: slots.map((slot, i) => {
      const d = designs[i] || makeSlotDesign();
      return {
        id: slot.id,
        label: slot.label,
        url: slot.localUrl || slot.url || "",
        slotState: {
          texts: d.texts.map(tb => ({ ...tb })),
          layers: d.layers.map(l => ({
            _id: l._id || undefined,
            url: l.src || l.url || l.urlImg || "",
            file: l.file,
            size: l.size,
            rotation: l.rotation,
            opacity: l.opacity,
            pos: { ...l.pos }
          })),
          instructions: d.instructions,
        },
      };
    }),
  });

  /* Disponibilité des boutons d'action */
  const canAddFace    = setSlots && slots.length < maxFaces;
  const canEditFace   = setSlots && !!slotDef;
  const canRemoveFace = setSlots && slots.length > 1;

  return (
    <div style={{display:"flex", flexDirection:"column", gap:16}}>

      {/* Métadonnées */}
      <div className="sd-card">
        <div className="sd-card-head">
          <span className="sd-card-icon">🏷️</span>
          <span className="sd-card-title">{text("t061", "Template Information")}</span>
        </div>
        <div className="sd-card-body" style={{flexDirection:"row", flexWrap:"wrap", gap:14}}>
          <div className="sd-field" style={{flex:"2 1 200px"}}>
            <label className="sd-lbl">{text("t062", "Template name *")}</label>
            <input className="sd-input" value={templateMeta.label}
              onChange={e => onMetaChange({...templateMeta, label:e.target.value})}
              placeholder={text("t063", "e.g. Street Eagle")}/>
          </div>
          <div className="sd-field" style={{flex:"1 1 140px"}}>
            <label className="sd-lbl">{text("t064", "Artistic style")}</label>
            <select className="sd-sel" value={templateMeta.style}
              onChange={e => onMetaChange({...templateMeta, style:e.target.value})}>
              {ARTISTIC_STYLES.map(s => <option key={s}>{s}</option>)}
            </select>
          </div>
          <div className="sd-field" style={{flex:"1 1 140px"}}>
            <label className="sd-lbl">{text("t065", "Detail level")}</label>
            <select className="sd-sel" value={templateMeta.detail}
              onChange={e => onMetaChange({...templateMeta, detail:e.target.value})}>
              {DETAIL_LEVELS.map(d => <option key={d}>{d}</option>)}
            </select>
          </div>
        </div>
      </div>

      {/* Studio */}
      <div className="sd-studio">
        <div className="sd-studio-left">

          {/* ══════════════════════════════════════════════════════
              🆕 ZONE 1 — Tabs + boutons "+" (add) et "✏️" (edit current)
          ══════════════════════════════════════════════════════ */}
          <div className="sd-face-tabs">
            {slots.map((slot, i) => (
              <button key={slot.id} type="button"
                className={`sd-face-tab${activeFace === i ? " on" : ""}`}
                onClick={e => {e.preventDefault(); setActiveFace(i);}}>
                {slot.label}
                {hasMods(i) && <span className="sd-face-dot"/>}
              </button>
            ))}

            {/* 🆕 Bouton "+" — Ajouter une face */}
            {canAddFace && (
              <button type="button"
                className="sd-face-action-btn add"
                onClick={e => { e.preventDefault(); handleAddFace(); }}
                title={elakayAutoText("h_e6805a3f42102a", "Add a face ({value0}/{value1})", { value0: slots.length, value1: maxFaces })}>
                <span style={{fontSize:14, lineHeight:1}}>+</span>
              </button>
            )}

            {/* 🆕 Bouton "✏️" — Éditer la face sélectionnée */}
            {canEditFace && (
              <button type="button"
                className="sd-face-action-btn edit"
                onClick={e => { e.preventDefault(); handleEditCurrentFace(); }}
                title={elakayAutoText("h_ae08fbdcf1afbe", "Edit \"{value0}\"", { value0: slotDef.label })}>
                <span style={{fontSize:11, lineHeight:1}}>✏️</span>
              </button>
            )}

            {/* ══════════════════════════════════════════════════════
                🆕 ZONE 2 — Thumbnails + bouton "🗑" (remove current)
            ══════════════════════════════════════════════════════ */}
            <div className="sd-face-thumbs">
              {slots.map((slot, i) => (
                <div key={slot.id} className={`sd-face-thumb${activeFace === i ? " on" : ""}`}
                  onClick={e => {e.preventDefault(); setActiveFace(i);}}>
                  {(slot.localUrl || slot.url) ?
                    <img src={slot.localUrl || slot.url} alt={slot.label}
                      onError={e2 => {e2.target.style.display = "none";}}/>
                    :
                    <span style={{fontSize:9, color:"var(--muted)"}}>{slot.label.slice(0,2)}</span>
                  }
                </div>
              ))}

              {/* 🆕 Bouton "🗑" — Supprimer la face sélectionnée */}
              {canRemoveFace && (
                <button type="button"
                  className="sd-face-action-btn remove"
                  onClick={e => { e.preventDefault(); handleRequestRemoveFace(); }}
                  title={elakayAutoText("h_48f99d2f375844", "Remove \"{value0}\"", { value0: slotDef.label })}>
                  <span style={{fontSize:11, lineHeight:1}}>🗑</span>
                </button>
              )}
            </div>
          </div>

          <div className="sd-canvas-zone">
            <DesignCanvas
              design={design}
              slotDef={slotDef}
              onUpdateTextBlock={(i, k, v) => updTextBlock(activeFace, i, k, v)}
              onUpdateLayer={handleUpdateLayerForCanvas}
              onAddLayer={l => addLayer(activeFace, l)}
              onSetActiveEl={el => setActiveEl(activeFace, el)}
              activeEl={activeEl[activeFace] ?? null}
              onZoomPan={(z, p) => updZoomPan(activeFace, z, p)}
            />
          </div>
        </div>

        <div className="sd-studio-right">
          <DesignControls
            design={design}
            onUpdateTextBlock={(i, k, v) => updTextBlock(activeFace, i, k, v)}
            onAddTextBlock={tb => addTextBlock(activeFace, tb)}
            onRemoveTextBlock={i => rmTextBlock(activeFace, i)}
            onUpdateLayer={(i, p) => updLayer(activeFace, i, p)}
            onAddLayer={l => addLayer(activeFace, l)}
            onRemoveLayer={i => rmLayer(activeFace, i)}
            onSetActiveEl={el => setActiveEl(activeFace, el)}
            activeEl={activeEl[activeFace] ?? null}
            onUpdateInstructions={v => updInstr(activeFace, v)}
            infoSource={infoSource}
          />
        </div>
      </div>

      {/* Progression */}
      <div className="sd-card">
        <div className="sd-card-head">
          <span className="sd-card-icon">📊</span>
          <span className="sd-card-title">{text("t066", "Design Progress")}</span>
          <span style={{
            fontSize:10, color:"var(--muted)",
            marginLeft:"auto", fontFamily:"var(--ffm)"
          }}>
            {slots.length} / {maxFaces}{__elakayText("t122", "faces")}</span>
        </div>
        <div className="sd-card-body">
          <div className="sd-stats">
            {slots.map((slot, i) => (
              <div key={slot.id} className="sd-stat"
                style={{cursor:"pointer", borderColor:activeFace === i ? "var(--gold)" : "var(--b)"}}
                onClick={() => setActiveFace(i)}>
                <span className="sd-stat-val" style={{fontSize:16, color:hasMods(i) ? "var(--ok)" : "var(--muted)"}}>
                  {hasMods(i) ? "✓" : "○"}
                </span>
                <span className="sd-stat-lbl">{slot.label}</span>
                {hasMods(i) &&
                  <div style={{fontSize:9, color:"var(--muted)"}}>
                    {designs[i]?.texts.length || 0}{__elakayText("t092", "T ·")}{designs[i]?.layers.length || 0}I
                  </div>
                }
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Actions */}
      <div style={{display:"flex", justifyContent:"space-between", alignItems:"center", flexWrap:"wrap", gap:10}}>
        <button type="button" className="sd-btn sd-btn-sec" onClick={onBack}>{__elakayText("t093", "← Step 1")}</button>
        <button type="button" className="sd-btn sd-btn-emerald" onClick={() => onPublish(buildOutput())}>{__elakayText("t094", "✅ Review & Publish →")}</button>
      </div>

      {/* 🆕 Styles pour les boutons d'action des faces */}
      <style>{`
        .sd-face-action-btn {
          width: 28px;
          height: 28px;
          margin: 4px;
          border-radius: 6px;
          border: 1px solid var(--b2);
          background: var(--n3);
          color: var(--muted);
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
          font-family: var(--ffb);
          font-weight: 700;
          transition: all .15s;
          flex-shrink: 0;
        }
        .sd-face-action-btn:hover:not(:disabled) {
          transform: scale(1.08);
        }
        .sd-face-action-btn.add {
          border-color: rgba(0,115,153,.4);
          color: var(--gold);
        }
        .sd-face-action-btn.add:hover {
          background: var(--golda);
          border-color: var(--gold);
        }
        .sd-face-action-btn.edit {
          border-color: rgba(0,180,216,.4);
          color: var(--teal);
        }
        .sd-face-action-btn.edit:hover {
          background: var(--teala);
          border-color: var(--teal);
        }
        .sd-face-action-btn.remove {
          border-color: rgba(239,68,68,.3);
          color: var(--err);
          opacity: 0.75;
        }
        .sd-face-action-btn.remove:hover {
          background: rgba(239,68,68,.1);
          border-color: var(--err);
          opacity: 1;
        }
        .sd-face-action-btn:disabled {
          opacity: 0.3;
          cursor: not-allowed;
        }
      `}</style>

      {/* 🆕 Modal d'édition de face */}
      <FaceEditModal
       setPickerOpen={setPickerOpen}
        setActiveSlotId={setActiveSlotId}
        open={editFaceOpen}
        slot={slotDef}
        infoSource={infoSource}
        onClose={() => setEditFaceOpen(false)}
        onSave={handleSaveFaceEdit}
      />

      {/* 🆕 Modal de confirmation de suppression */}
      <ConfirmRemoveFaceModal
        open={confirmRemoveOpen}
        slot={slotDef}
        infoSource={infoSource}
        onCancel={() => setConfirmRemoveOpen(false)}
        onConfirm={handleConfirmRemoveFace}
      />
        <ImagePickerModal
                open={open}
                onClose={() => setPickerOpen(false)}
                slots={slots}
                setSlots={setSlots}
                ImageGallery={ImageGallery}
                images={images}
                slotId={slotId}
                infoSource={infoSource}
              />
    </div>
  );
}

/* ══════════════════════════════════════════════════════
   Exports nommés
══════════════════════════════════════════════════════ */
export {
  DesignCanvas,
  DesignControls,
  makeSlotDesign,
  makeTextBlock,
  makeNewSlot,
  buildSavePayload,
  useDesignSave,
  useGraphicOrderSave,
  SaveStatusBar,
  ImagePickerModal,
  SlotManager,
  FaceEditModal,
  ConfirmRemoveFaceModal,
   CSS_
};
